// // // import { useState, useEffect } from "react";
// // // import Button from "@mui/material/Button";
// // // import DaysCalendar from "./DaysCalendar";
// // // import HoursCalendar from "./HoursCalendar";
// // // import DoctorDayView from "./DoctorDayView"; // Import the new component
// // // import axiosClient from "../axiosClient";
// // // import { useStateContext } from "../context/ContextProvider";
// // // import AppointmentEditModal from "./AppointmentEditModal";

// // // import {
// // //   Dialog,
// // //   DialogActions,
// // //   DialogContent,
// // //   DialogTitle,
// // //   TextField,
// // //   FormControl,
// // //   InputLabel,
// // //   Select,
// // //   MenuItem,
// // //   FormGroup,
// // //   FormControlLabel,
// // //   Checkbox,
// // //   Box,
// // //   List,
// // //   ListItem,
// // //   ListItemText,
// // //   ToggleButtonGroup,
// // //   ToggleButton,
// // // } from "@mui/material";
// // // import { useTranslation } from "react-i18next";
// // // import AppointmentAlerts from "./AppointmentReminder";
// // // import CalendarCheckbox from "./SmallCalendar";

// // // function FullCalendarApp() {
// // //   const [view, setCalendarView] = useState("dayGridMonth");
// // //   const [dayViewMode, setDayViewMode] = useState("hourView"); // "hourView" or "doctorView"
// // //   const [events, setEvents] = useState([]);
// // //   const [open, setOpen] = useState(false);
// // //   const [displayComment, setDisplayComment] = useState(false); // Default checked

// // //   const [openEditModal, setOpenEditModal] = useState(false);
// // //   const [selectedEvent, setSelectedEvent] = useState();

// // //   const [date, setDate] = useState("");

// // //   const [startTime, setStartTime] = useState("");
// // //   const [endTime, setEndTime] = useState("");

// // //   const { t } = useTranslation();

// // //   const [color] = useState("#ffffff");
// // //   // const [formData, setFormData] = useState({
// // //   //   client_id: "",
// // //   //   staff_id: "",
// // //   //   appointment_start_time_str: "",
// // //   //   appointment_finish_time_str: "",
// // //   // });

// // //   const [staffUsers, setStaffUsers] = useState([]);
// // //   const [clientUsers, setClientUsers] = useState([]);
// // //   const [allClientUsers, setAllClientUsers] = useState([]);

// // //   const [selectedClient, setSelectedClient] = useState("");
// // //   const [selectedStaff, setSelectedStaff] = useState("");

// // //   const [isSendEmail, setIsSendEmail] = useState(false);
// // //   const [isSendSMS, setIsSendSMS] = useState(false);
// // //   const [smsLanguage, setSmsLanguage] = useState("en"); // Language for SMS (en or el)
// // //   // const [isCheckEarlier, setIsCheckEarlier] = useState(false);
// // //   const [earlierPatientsList, setEarlierPatientsList] = useState([]);
// // //   const [selectedDateCalendar, setSelectedDateCalendar] = useState(new Date());

// // //   const { user, setView } = useStateContext();

// // //   const getEarlierPatients = (selectedStaff) => {
// // //     axiosClient
// // //       .get(
// // //         "api/print_appointments/?earlier_date=" +
// // //         date +
// // //         "&staff=" +
// // //         selectedStaff
// // //       )
// // //       .then((data) => {
// // //         setEarlierPatientsList(data.data);
// // //       })
// // //       .catch((err) => {
// // //         console.log(err);
// // //       });
// // //   };

// // //   useEffect(() => {
// // //     if (selectedDateCalendar && selectedStaff) {
// // //       getEarlierPatients(selectedStaff);
// // //     }
// // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // //   }, [selectedDateCalendar, selectedStaff]);

// // //   useEffect(() => {
// // //     if (open) {
// // //       setEarlierPatientsList([]);
// // //     }
// // //   }, [open]);

// // //   const formatTime = (date) => {
// // //     const hours = String(date.getHours()).padStart(2, "0");
// // //     const minutes = String(date.getMinutes()).padStart(2, "0");
// // //     return `${hours}:${minutes}`;
// // //   };

// // //   const formatDate = (date) => {
// // //     const year = date.getFullYear();
// // //     const month = String(date.getMonth() + 1).padStart(2, "0");
// // //     const day = String(date.getDate()).padStart(2, "0");
// // //     return `${year}-${month}-${day}`;
// // //   };

// // //   const handleSwitchView = () => {
// // //     setCalendarView(view === "dayGridMonth" ? "timeGridDay" : "dayGridMonth");
// // //   };

// // //   const handleDayViewModeChange = (event, newMode) => {
// // //     if (newMode !== null) {
// // //       setDayViewMode(newMode);
// // //     }
// // //   };

// // //   const handleEditModalClose = () => {
// // //     setOpenEditModal(false);
// // //   };

// // //   const getEventList = () => {
// // //     axiosClient
// // //       .get("api/print_appointments/")
// // //       .then((data) => {
// // //         const correctData = data.data.filter((event) => {
// // //           if (
// // //             (event.staff_name === user.first_name &&
// // //               event.staff_surname === user.last_name &&
// // //               user.user_role === "STAFF") ||
// // //             (event.client_name === user.first_name &&
// // //               event.client_surname === user.last_name &&
// // //               user.user_role === "CLIENT") ||
// // //             user.user_role === "ADMIN"
// // //           ) {
// // //             return event;
// // //           }
// // //           return null;
// // //         });
// // //         const transformedResult = correctData.map((value) => {
// // //           return {
// // //             title: `${value.client_name} ${value.client_surname}`,
// // //             start: `${value.appointment_date}T${value.appointment_start}`,
// // //             end: `${value.appointment_date}T${value.appointment_end}`,
// // //             clr: value.color || "#000000",
// // //             appointmentId: value?.id,
// // //             user_reminder: value?.user_reminder,
// // //             appointment_date: value.appointment_date,
// // //             id: value.id,
// // //             staff_id: value.staff_id, // Add staff_id to the event
// // //           };
// // //         });
// // //         setEvents(transformedResult);
// // //       })
// // //       .catch((err) => {
// // //         console.log(err);
// // //       });
// // //   };

// // //   useEffect(() => {
// // //     if (user?.user_role === "STAFF" || user?.user_role === "ADMIN") {
// // //       getEventList();
// // //     }

// // //     if (user?.user_role === "CLIENT") {
// // //       axiosClient
// // //         .get(`api/client-appointments/${user?.id}`)
// // //         .then((res) => {
// // //           const transformedResult = res?.data?.map((value) => {
// // //             return {
// // //               title: `${value.staff_name} ${value.staff_surname}`,
// // //               start: `${value.appointment_date}T${value.appointment_start}`,
// // //               end: `${value.appointment_date}T${value.appointment_end}`,
// // //               clr: value.color || "#000000",
// // //               appointmentId: value?.id,
// // //               staff_id: value.staff_id, // Add staff_id to the event
// // //             };
// // //           });
// // //           setEvents(transformedResult);
// // //         })
// // //         .catch((err) => {
// // //           console.log(err);
// // //         });
// // //     }
// // //     // eslint-disable-next-line
// // //   }, [user]);

// // //   const handleSendEmail = (id) => {
// // //     axiosClient
// // //       .post("api/send_email/", {
// // //         appointment_id: id,
// // //       })
// // //       .then((res) => {
// // //         console.log("Email sent");
// // //       })
// // //       .catch((error) => {
// // //         console.log(error);
// // //       });
// // //   };

// // //   const handleSendSMS = (id) => {
// // //     axiosClient
// // //       .post(`api/send_appointment_info/${id}/`, {
// // //         language: smsLanguage,
// // //       })
// // //       .then((res) => {
// // //         console.log("SMS sent");
// // //       })
// // //       .catch((error) => {
// // //         console.log(error);
// // //       });
// // //   };

// // //   useEffect(() => {
// // //     if (user?.user_role === "ADMIN" || user?.user_role === "STAFF") {
// // //       Promise.all([
// // //         axiosClient.get("api/staff-users/"),
// // //         axiosClient.get("api/client-users/"),
// // //       ]).then(([staffRes, clientRes]) => {
// // //         setStaffUsers(staffRes?.data);
// // //         setClientUsers(clientRes?.data);
// // //         setAllClientUsers(clientRes?.data); // Store all clients
// // //       });
// // //     }
// // //   }, [user]);

// // //   useEffect(() => {
// // //     if (selectedStaff && allClientUsers.length > 0) {
// // //       const filteredData = allClientUsers.filter(
// // //         (user) => user.assigned_staff === selectedStaff
// // //       );
// // //       setClientUsers(filteredData.length > 0 ? filteredData : allClientUsers);
// // //     }
// // //     // eslint-disable-next-line
// // //   }, [selectedStaff, allClientUsers]);

// // //   const handleDateClick = (arg) => {
// // //     setCalendarView("timeGridDay");
// // //     setDate(arg.dateStr);
// // //     // if (user?.user_role === 'STAFF' || user?.user_role === 'ADMIN') {
// // //     //   setDate(arg.dateStr);
// // //     //   setOpen(true);
// // //     // }
// // //   };

// // //   const handleHourClick = (arg) => {
// // //     console.log("Hour click event:", arg);

// // //     if (user?.user_role === "STAFF" || user?.user_role === "ADMIN") {
// // //       setOpen(true);

// // //       // Handle clicks from both regular hour view and doctor view
// // //       let clickDate, clickTime;

// // //       if (arg.dateStr) {
// // //         // Regular hour view click
// // //         const dateTime = new Date(arg.dateStr);
// // //         clickDate = formatDate(dateTime);
// // //         clickTime = new Date(arg.dateStr);
// // //       } else if (arg.date) {
// // //         // Doctor view click
// // //         const dateTime = new Date(arg.date);
// // //         clickDate = formatDate(dateTime);
// // //         clickTime = dateTime;

// // //         // If there's a resource/staff selected in doctor view
// // //         if (arg.resource && arg.staff_id) {
// // //           setSelectedStaff(arg.staff_id);
// // //         }
// // //       } else {
// // //         // Direct time object (from the "Add" button)
// // //         clickDate = formatDate(arg);
// // //         clickTime = arg;
// // //       }

// // //       setDate(clickDate);

// // //       const startTime = clickTime;
// // //       const endTime = new Date(startTime.getTime() + 30 * 60000);

// // //       setStartTime(formatTime(startTime));
// // //       setEndTime(formatTime(endTime));
// // //     }
// // //   };

// // //   const handleClose = () => {
// // //     setOpen(false);
// // //     setSelectedClient("");
// // //     setSelectedStaff("");
// // //     setStartTime("");
// // //     setEndTime("");
// // //   };

// // //   const handleEventClick = (event) => {
// // //     if (user?.user_role === "STAFF" || user?.user_role === "ADMIN") {
// // //       setOpenEditModal(true);
// // //       setSelectedEvent(event?.event?.extendedProps?.appointmentId);
// // //     }
// // //   };

// // //   const [comment, setComment] = useState("");
// // //   const [visibility, setVisibility] = useState(true);
// // //   const handleSubmit = () => {
// // //     // Check if the comment is required
// // //     if (displayComment) {
// // //       if (!comment || typeof comment !== "string" || !comment.trim()) {
// // //         alert("Please fill out the required comment field.");
// // //         return; // Exit if the comment is invalid
// // //       }
// // //     }

// // //     if (
// // //       !selectedClient ||
// // //       !selectedStaff ||
// // //       !startTime ||
// // //       !endTime ||
// // //       !date ||
// // //       !color
// // //     ) {
// // //       alert("Please fill out all required fields.");
// // //       return;
// // //     }
// // //     const payload = {
// // //       client_id: selectedClient,
// // //       staff_id: selectedStaff,
// // //       appointment_start_time_str: startTime,
// // //       appointment_finish_time_str: endTime,
// // //       appointment_date: date,
// // //       color: color,
// // //     };
// // //     if (selectedDateCalendar) {
// // //       const date = formatDate(selectedDateCalendar);
// // //       payload.earlier_date = date;
// // //     }

// // //     axiosClient
// // //       .post("api/appointment/", payload)
// // //       .then((response) => {
// // //         if (response?.status === 201) {
// // //           // Handle optional actions
// // //           if (displayComment) handleSave(response?.data?.id);
// // //           if (isSendEmail) handleSendEmail(response?.data?.id);
// // //           if (isSendSMS) handleSendSMS(response?.data?.id);

// // //           // Refresh and close modal
// // //           getEventList();
// // //           handleClose();
// // //         }
// // //       })
// // //       .catch((err) => {
// // //         const errorMessage =
// // //           err.response?.data?.error || "An error occurred. Please try again.";
// // //         console.error("Submission Error:", errorMessage);
// // //         alert(errorMessage);
// // //       });
// // //   };

// // //   const handleSave = async (id) => {
// // //     try {
// // //       const response = await axiosClient.post("api/comments/create/", {
// // //         appointment: id,
// // //         comment_text: comment,
// // //         visibility: visibility,
// // //       });
// // //       console.log("Comment saved:", response.data);
// // //       setComment("");
// // //     } catch (error) {
// // //       // Log the full error response
// // //       if (error.response) {
// // //         console.error("Error response:", error.response);
// // //         alert(`Error saving comment: ${error.response.data}`);
// // //       } else {
// // //         console.error("Error saving comment:", error);
// // //       }
// // //     }
// // //   };
// // //   // const handleInputChange = (e) => {
// // //   //   const { name, value } = e.target;
// // //   //   setFormData((prevData) => ({
// // //   //     ...prevData,
// // //   //     [name]: value,
// // //   //   }));
// // //   // };

// // //   return (
// // //     <div>
// // //       <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
// // //         <Button variant="contained" onClick={handleSwitchView}>
// // //           {view === "dayGridMonth"
// // //             ? `${t("Switch to Daily Schedule")}`
// // //             : `${t("Switch to Month View")}`}
// // //         </Button>

// // //         {view === "timeGridDay" && (
// // //           <ToggleButtonGroup
// // //             value={dayViewMode}
// // //             exclusive
// // //             onChange={handleDayViewModeChange}
// // //             aria-label="day view mode"
// // //           >
// // //             <ToggleButton value="hourView" aria-label="hour view">
// // //               {t("Hour View")}
// // //             </ToggleButton>
// // //             <ToggleButton value="doctorView" aria-label="doctor view">
// // //               {t("Doctor View")}
// // //             </ToggleButton>
// // //           </ToggleButtonGroup>
// // //         )}
// // //       </Box>

// // //       {view === "dayGridMonth" ? (
// // //         <DaysCalendar
// // //           events={events}
// // //           onDateClick={handleDateClick}
// // //           onEventClick={handleEventClick}
// // //         />
// // //       ) : dayViewMode === "hourView" ? (
// // //         <HoursCalendar
// // //           events={events}
// // //           onDateClick={handleHourClick}
// // //           onEventClick={handleEventClick}
// // //           date={date}
// // //         />
// // //       ) : (
// // //         <DoctorDayView
// // //           events={events}
// // //           staffUsers={staffUsers}
// // //           onDateClick={handleHourClick}
// // //           onEventClick={handleEventClick}
// // //           date={date}
// // //         />
// // //       )}

// // //       <Dialog fullWidth open={open} onClose={handleClose}>
// // //         <DialogTitle>{t("Add New Appointment")}</DialogTitle>
// // //         <Box
// // //           fullWidth
// // //           sx={{ display: "flex", gap: 2, mx: 3, justifyContent: "center" }}
// // //         >
// // //           <Button
// // //             onClick={() => setView("edit_delete_appointment")}
// // //             variant="contained"
// // //           >
// // //             {t("Edit / Delete Appointment")}
// // //           </Button>
// // //           <Button onClick={() => setView("staff")} variant="contained">
// // //             {t("Client to Staff")}
// // //           </Button>
// // //         </Box>
// // //         <DialogContent>
// // //           <FormControl
// // //             fullWidth
// // //             variant="outlined"
// // //             sx={{ marginBottom: "1rem" }}
// // //           >
// // //             <InputLabel id="staff-select-label">{t("Select Staff")}</InputLabel>
// // //             <Select
// // //               labelId="staff-select-label"
// // //               value={selectedStaff}
// // //               onChange={(e) => setSelectedStaff(e.target.value)}
// // //               label={`${t("Select Staff")}`}
// // //               required
// // //             >
// // //               {staffUsers.map((st, i) => (
// // //                 <MenuItem
// // //                   key={i}
// // //                   value={st.id}
// // //                   lastname={st.custom_user.last_name}
// // //                 >{`${st.custom_user.first_name} ${st.custom_user.last_name}`}</MenuItem>
// // //               ))}
// // //             </Select>
// // //           </FormControl>
// // //           <FormControl
// // //             fullWidth
// // //             variant="outlined"
// // //             sx={{ marginBottom: "1rem" }}
// // //           >
// // //             <InputLabel id="client-select-label">
// // //               {t("Select Client")}
// // //             </InputLabel>
// // //             <Select
// // //               labelId="client-select-label"
// // //               value={selectedClient}
// // //               onChange={(e) => setSelectedClient(e.target.value)}
// // //               label={`${t("Select Client")}`}
// // //               required
// // //             >
// // //               {clientUsers.map((user, i) => (
// // //                 <MenuItem
// // //                   key={i}
// // //                   value={user.id}
// // //                   lastname={user.custom_user.last_name}
// // //                 >{`${user.custom_user.first_name} ${user.custom_user.last_name}`}</MenuItem>
// // //               ))}
// // //             </Select>
// // //           </FormControl>
// // //           <TextField
// // //             fullWidth
// // //             type="time"
// // //             label={`${t("Time of Appointment (start)")}`}
// // //             variant="outlined"
// // //             InputLabelProps={{ shrink: true }}
// // //             name="appointment_start_time_str"
// // //             value={startTime || ""}
// // //             onChange={(e) => {
// // //               setStartTime(e.target.value);
// // //             }}
// // //             sx={{ marginBottom: "1rem" }}
// // //             required
// // //           />
// // //           <TextField
// // //             fullWidth
// // //             type="time"
// // //             label={`${t("Time of Appointment (end)")}`}
// // //             variant="outlined"
// // //             InputLabelProps={{ shrink: true }}
// // //             name="appointment_finish_time_str"
// // //             value={endTime || ""}
// // //             onChange={(e) => setEndTime(e.target.value)}
// // //             sx={{ marginBottom: "1rem" }}
// // //             required
// // //           />

// // //           <FormControlLabel
// // //             control={
// // //               <Checkbox
// // //                 onChange={(e) => setDisplayComment(e.target.checked)} // Set visibility state based on checkbox
// // //               />
// // //             }
// // //             label="Comment"
// // //           />
// // //           {displayComment && (
// // //             <Box>
// // //               <FormGroup sx={{ mt: 3 }}>
// // //                 <FormControlLabel
// // //                   control={
// // //                     <Checkbox
// // //                       onChange={(e) => setVisibility(e.target.checked)} // Use e.target.checked
// // //                     />
// // //                   }
// // //                   label="View By Client"
// // //                 />
// // //                 <TextField
// // //                   fullWidth
// // //                   multiline
// // //                   rows={1}
// // //                   value={comment}
// // //                   variant="outlined"
// // //                   onChange={(e) => setComment(e.target.value)}
// // //                   placeholder="Enter your comment"
// // //                   sx={{ my: 1 }}
// // //                 />
// // //               </FormGroup>
// // //             </Box>
// // //           )}
// // //           <Box display={"flex"}>
// // //             <FormGroup sx={{ mt: 3 }}>
// // //               <FormControlLabel
// // //                 control={
// // //                   <Checkbox
// // //                     onChange={(e) => setIsSendEmail(e.target.checked)}
// // //                   />
// // //                 }
// // //                 label={`${t("Send Email to client")}`}
// // //               />
// // //               <FormControlLabel
// // //                 control={
// // //                   <Checkbox onChange={(e) => setIsSendSMS(e.target.checked)} />
// // //                 }
// // //                 label={`${t("Send SMS to client")}`}
// // //               />
// // //               {isSendSMS && (
// // //                 <FormControl size="small" sx={{ minWidth: 120, ml: 4, mb: 1 }}>
// // //                   <InputLabel>{t("SMS Language")}</InputLabel>
// // //                   <Select
// // //                     value={smsLanguage}
// // //                     label={t("SMS Language")}
// // //                     onChange={(e) => setSmsLanguage(e.target.value)}
// // //                   >
// // //                     <MenuItem value="en">{t("English")}</MenuItem>
// // //                     <MenuItem value="el">{t("Greek")}</MenuItem>
// // //                   </Select>
// // //                 </FormControl>
// // //               )}
// // //               <CalendarCheckbox
// // //                 selectedDateCalendar={selectedDateCalendar}
// // //                 setSelectedDateCalendar={setSelectedDateCalendar}
// // //               />
// // //             </FormGroup>
// // //             <Box
// // //               sx={{
// // //                 maxWidth: "100%",
// // //                 overflowX: "auto",
// // //                 border: "1px solid black",
// // //                 padding: 2,
// // //                 maxHeight: "300px",
// // //               }}
// // //             >
// // //               <h4>Patients</h4>

// // //               <List>
// // //                 {earlierPatientsList.map((patient) => (
// // //                   <ListItem key={patient.id} divider>
// // //                     <ListItemText primary={patient.client_name} />
// // //                   </ListItem>
// // //                 ))}
// // //               </List>
// // //             </Box>
// // //           </Box>
// // //         </DialogContent>
// // //         <DialogActions>
// // //           <Button onClick={handleClose} color="primary">
// // //             {t("Cancel")}
// // //           </Button>
// // //           <Button onClick={handleSubmit} color="primary">
// // //             {t("Submit")}
// // //           </Button>
// // //         </DialogActions>
// // //       </Dialog>
// // //       <AppointmentEditModal
// // //         open={openEditModal}
// // //         id={selectedEvent}
// // //         handleClose={handleEditModalClose}
// // //         getAppointment={getEventList}
// // //         isDelete={true}
// // //       />
// // //       {user && (user.user_role === "STAFF" || user.user_role === "ADMIN") && (
// // //         <AppointmentAlerts appointments={events} />
// // //       )}
// // //     </div>
// // //   );
// // // }

// // // export default FullCalendarApp;



// // import { useState, useEffect } from "react";
// // import Button from "@mui/material/Button";
// // import DaysCalendar from "./DaysCalendar";
// // import HoursCalendar from "./HoursCalendar";
// // import DoctorDayView from "./DoctorDayView";
// // import axiosClient from "../axiosClient";
// // import { useStateContext } from "../context/ContextProvider";
// // import AppointmentEditModal from "./AppointmentEditModal";
// // import {
// //   Dialog,
// //   DialogActions,
// //   DialogContent,
// //   DialogTitle,
// //   TextField,
// //   FormControl,
// //   InputLabel,
// //   Select,
// //   MenuItem,
// //   Box,
// //   ToggleButtonGroup,
// //   ToggleButton,
// // } from "@mui/material";
// // import { useTranslation } from "react-i18next";

// // function FullCalendarApp() {
// //   const [view, setCalendarView] = useState("dayGridMonth");
// //   const [dayViewMode, setDayViewMode] = useState("hourView");
// //   const [events, setEvents] = useState([]);
// //   const [open, setOpen] = useState(false);

// //   const [openEditModal, setOpenEditModal] = useState(false);
// //   const [selectedEventId, setSelectedEventId] = useState(null);

// //   const [date, setDate] = useState("");
// //   const [startTime, setStartTime] = useState("");
// //   const [endTime, setEndTime] = useState("");

// //   const { t } = useTranslation();
// //   const { user } = useStateContext();

// //   // NEW DATA
// //   const [technicians, setTechnicians] = useState([]);
// //   const [issues, setIssues] = useState([]);
// //   const [selectedTechnician, setSelectedTechnician] = useState("");
// //   const [selectedIssue, setSelectedIssue] = useState("");

// //   const formatTime = (d) => {
// //     const hours = String(d.getHours()).padStart(2, "0");
// //     const minutes = String(d.getMinutes()).padStart(2, "0");
// //     return `${hours}:${minutes}`;
// //   };

// //   const formatDate = (d) => {
// //     const year = d.getFullYear();
// //     const month = String(d.getMonth() + 1).padStart(2, "0");
// //     const day = String(d.getDate()).padStart(2, "0");
// //     return `${year}-${month}-${day}`;
// //   };

// //   const handleSwitchView = () => {
// //     setCalendarView(view === "dayGridMonth" ? "timeGridDay" : "dayGridMonth");
// //   };

// //   const handleDayViewModeChange = (event, newMode) => {
// //     if (newMode !== null) setDayViewMode(newMode);
// //   };

// //   const handleEditModalClose = () => setOpenEditModal(false);

// //   // ✅ Load technicians + issues
// //   useEffect(() => {
// //     if (!user) return;

// //     Promise.all([
// //       axiosClient.get("/auth/technicians/"),
// //       axiosClient.get("/api/issues/"),
// //     ])
// //       .then(([techRes, issueRes]) => {
// //         setTechnicians(techRes.data || []);
// //         setIssues(issueRes.data || []);
// //       })
// //       .catch((err) => console.log(err));
// //   }, [user]);

// //   // ✅ Load appointments -> events
// //   const getEventList = () => {
// //     axiosClient
// //       .get("/api/appointments/")
// //       .then((res) => {
// //         const data = res.data || [];
// //         const transformed = data.map((a) => {
// //           const issueTitle = a.issue_info?.title || `Issue #${a.issue}`;
// //           const techName =
// //             a.technician_info
// //               ? `${a.technician_info.first_name || ""} ${a.technician_info.last_name || ""}`.trim()
// //               : `Tech #${a.technician}`;

// //           return {
// //             title: `${issueTitle} (${techName})`,
// //             start: `${a.appointment_date}T${a.appointment_start}`,
// //             end: `${a.appointment_date}T${a.appointment_end}`,
// //             appointmentId: a.id,
// //             id: a.id,
// //           };
// //         });
// //         setEvents(transformed);
// //       })
// //       .catch((err) => console.log(err));
// //   };

// //   useEffect(() => {
// //     if (user) getEventList();
// //     // eslint-disable-next-line
// //   }, [user]);

// //   const handleDateClick = (arg) => {
// //     setCalendarView("timeGridDay");
// //     setDate(arg.dateStr);
// //   };

// //   const handleHourClick = (arg) => {
// //     if (!user) return;

// //     setOpen(true);

// //     let clickDate, clickTime;

// //     if (arg.dateStr) {
// //       const dt = new Date(arg.dateStr);
// //       clickDate = formatDate(dt);
// //       clickTime = dt;
// //     } else if (arg.date) {
// //       const dt = new Date(arg.date);
// //       clickDate = formatDate(dt);
// //       clickTime = dt;
// //     } else {
// //       clickDate = formatDate(arg);
// //       clickTime = arg;
// //     }

// //     setDate(clickDate);

// //     const start = clickTime;
// //     const end = new Date(start.getTime() + 30 * 60000);

// //     setStartTime(formatTime(start));
// //     setEndTime(formatTime(end));
// //   };

// //   const handleClose = () => {
// //     setOpen(false);
// //     setSelectedIssue("");
// //     setSelectedTechnician("");
// //     setStartTime("");
// //     setEndTime("");
// //   };

// //   const handleEventClick = (event) => {
// //     setOpenEditModal(true);
// //     setSelectedEventId(event?.event?.extendedProps?.appointmentId);
// //   };

// //   const handleSubmit = () => {
// //     if (!selectedIssue || !selectedTechnician || !startTime || !endTime || !date) {
// //       alert("Please fill out all required fields.");
// //       return;
// //     }

// //     const payload = {
// //       issue: Number(selectedIssue),
// //       technician: Number(selectedTechnician),
// //       appointment_date: date,
// //       appointment_start: startTime.length === 5 ? `${startTime}:00` : startTime,
// //       appointment_end: endTime.length === 5 ? `${endTime}:00` : endTime,
// //     };

// //     axiosClient
// //       .post("/api/appointments/", payload)
// //       .then(() => {
// //         getEventList();
// //         handleClose();
// //       })
// //       .catch((err) => {
// //         console.log(err);
// //         alert(err?.response?.data?.detail || "Failed to create appointment");
// //       });
// //   };

// //   return (
// //     <div>
// //       <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
// //         <Button variant="contained" onClick={handleSwitchView}>
// //           {view === "dayGridMonth" ? t("Switch to Daily Schedule") : t("Switch to Month View")}
// //         </Button>

// //         {view === "timeGridDay" && (
// //           <ToggleButtonGroup
// //             value={dayViewMode}
// //             exclusive
// //             onChange={handleDayViewModeChange}
// //             aria-label="day view mode"
// //           >
// //             <ToggleButton value="hourView">{t("Hour View")}</ToggleButton>
// //             <ToggleButton value="doctorView">{t("Doctor View")}</ToggleButton>
// //           </ToggleButtonGroup>
// //         )}
// //       </Box>

// //       {view === "dayGridMonth" ? (
// //         <DaysCalendar events={events} onDateClick={handleDateClick} onEventClick={handleEventClick} />
// //       ) : dayViewMode === "hourView" ? (
// //         <HoursCalendar events={events} onDateClick={handleHourClick} onEventClick={handleEventClick} date={date} />
// //       ) : (
// //         <DoctorDayView
// //           events={events}
// //           staffUsers={technicians} // keep prop name to avoid breaking DoctorDayView
// //           onDateClick={handleHourClick}
// //           onEventClick={handleEventClick}
// //           date={date}
// //         />
// //       )}

// //       <Dialog fullWidth open={open} onClose={handleClose}>
// //         <DialogTitle>{t("Add New Appointment")}</DialogTitle>
// //         <DialogContent>
// //           <FormControl fullWidth variant="outlined" sx={{ marginBottom: "1rem" }}>
// //             <InputLabel id="tech-select-label">{t("Select Technician")}</InputLabel>
// //             <Select
// //               labelId="tech-select-label"
// //               value={selectedTechnician}
// //               onChange={(e) => setSelectedTechnician(e.target.value)}
// //               label={t("Select Technician")}
// //               required
// //             >
// //               {technicians.map((tech) => (
// //                 <MenuItem key={tech.id} value={tech.user}>
// //                   {tech.user_first_name} {tech.user_last_name} ({tech.user_email})
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>

// //           <FormControl fullWidth variant="outlined" sx={{ marginBottom: "1rem" }}>
// //             <InputLabel id="issue-select-label">{t("Select Issue")}</InputLabel>
// //             <Select
// //               labelId="issue-select-label"
// //               value={selectedIssue}
// //               onChange={(e) => setSelectedIssue(e.target.value)}
// //               label={t("Select Issue")}
// //               required
// //             >
// //               {issues.map((iss) => (
// //                 <MenuItem key={iss.id} value={iss.id}>
// //                   #{iss.id} - {iss.title}
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>

// //           <TextField
// //             fullWidth
// //             type="time"
// //             label={t("Time of Appointment (start)")}
// //             variant="outlined"
// //             InputLabelProps={{ shrink: true }}
// //             value={startTime || ""}
// //             onChange={(e) => setStartTime(e.target.value)}
// //             sx={{ marginBottom: "1rem" }}
// //             required
// //           />

// //           <TextField
// //             fullWidth
// //             type="time"
// //             label={t("Time of Appointment (end)")}
// //             variant="outlined"
// //             InputLabelProps={{ shrink: true }}
// //             value={endTime || ""}
// //             onChange={(e) => setEndTime(e.target.value)}
// //             sx={{ marginBottom: "1rem" }}
// //             required
// //           />
// //         </DialogContent>

// //         <DialogActions>
// //           <Button onClick={handleClose} color="primary">
// //             {t("Cancel")}
// //           </Button>
// //           <Button onClick={handleSubmit} color="primary">
// //             {t("Submit")}
// //           </Button>
// //         </DialogActions>
// //       </Dialog>

// //       <AppointmentEditModal
// //         open={openEditModal}
// //         id={selectedEventId}
// //         handleClose={handleEditModalClose}
// //         refresh={getEventList}
// //       />
// //     </div>
// //   );
// // }

// // export default FullCalendarApp;



// ///////////////////////////////////////////////////////////////////////////////////////

// // import { useState, useEffect } from "react";
// // import Button from "@mui/material/Button";
// // import DaysCalendar from "./DaysCalendar";
// // import HoursCalendar from "./HoursCalendar";
// // import DoctorDayView from "./DoctorDayView";
// // import axiosClient from "../axiosClient";
// // import { useStateContext } from "../context/ContextProvider";
// // import AppointmentEditModal from "./AppointmentEditModal";
// // import {
// //   Dialog,
// //   DialogActions,
// //   DialogContent,
// //   DialogTitle,
// //   TextField,
// //   FormControl,
// //   InputLabel,
// //   Select,
// //   MenuItem,
// //   Box,
// //   ToggleButtonGroup,
// //   ToggleButton,
// //   Alert
// // } from "@mui/material";
// // import { useTranslation } from "react-i18next";

// // function FullCalendarApp() {
// //   const [view, setCalendarView] = useState("dayGridMonth");
// //   const [dayViewMode, setDayViewMode] = useState("hourView");
// //   const [events, setEvents] = useState([]);
// //   const [open, setOpen] = useState(false);

// //   const [openEditModal, setOpenEditModal] = useState(false);
// //   const [selectedEventId, setSelectedEventId] = useState(null);

// //   const [date, setDate] = useState("");
// //   const [startTime, setStartTime] = useState("");
// //   const [endTime, setEndTime] = useState("");

// //   const { t } = useTranslation();
// //   const { user } = useStateContext();

// //   const [technicians, setTechnicians] = useState([]);
// //   const [issues, setIssues] = useState([]);
// //   const [selectedTechnician, setSelectedTechnician] = useState("");
// //   const [selectedIssue, setSelectedIssue] = useState("");
// //   const [selectedIssueRoom, setSelectedIssueRoom] = useState(""); // 🆕 State for the room

// //   const formatTime = (d) => {
// //     const hours = String(d.getHours()).padStart(2, "0");
// //     const minutes = String(d.getMinutes()).padStart(2, "0");
// //     return `${hours}:${minutes}`;
// //   };

// //   const formatDate = (d) => {
// //     const year = d.getFullYear();
// //     const month = String(d.getMonth() + 1).padStart(2, "0");
// //     const day = String(d.getDate()).padStart(2, "0");
// //     return `${year}-${month}-${day}`;
// //   };

// //   const handleSwitchView = () => {
// //     setCalendarView(view === "dayGridMonth" ? "timeGridDay" : "dayGridMonth");
// //   };

// //   const handleDayViewModeChange = (event, newMode) => {
// //     if (newMode !== null) setDayViewMode(newMode);
// //   };

// //   const handleEditModalClose = () => setOpenEditModal(false);

// //   useEffect(() => {
// //     if (!user) return;

// //     Promise.all([
// //       axiosClient.get("/auth/technicians/"),
// //       axiosClient.get("/api/issues/"),
// //     ])
// //       .then(([techRes, issueRes]) => {
// //         setTechnicians(techRes.data || []);
// //         setIssues(issueRes.data || []);
// //       })
// //       .catch((err) => console.log(err));
// //   }, [user]);

// //   // ✅ UPDATED: Added room number to event title
// //   const getEventList = () => {
// //     axiosClient
// //       .get("/api/appointments/")
// //       .then((res) => {
// //         const data = res.data || [];
// //         const transformed = data.map((a) => {
// //           const issueTitle = a.issue_info?.title || `Issue #${a.issue}`;
          
// //           // 🛠️ Extract Room Number from issue_info
// //           const room = a.issue_info?.room_number ? ` [Room: ${a.issue_info.room_number}]` : "";
          
// //           const techName =
// //             a.technician_info
// //               ? `${a.technician_info.first_name || ""} ${a.technician_info.last_name || ""}`.trim()
// //               : `Tech #${a.technician}`;

// //           return {
// //             // 🆕 New title format: Issue (Tech) [Room]
// //             title: `${issueTitle} (${techName})${room}`,
// //             start: `${a.appointment_date}T${a.appointment_start}`,
// //             end: `${a.appointment_date}T${a.appointment_end}`,
// //             appointmentId: a.id,
// //             id: a.id,
// //             extendedProps: { room_number: a.issue_info?.room_number } // Extra data for modal
// //           };
// //         });
// //         setEvents(transformed);
// //       })
// //       .catch((err) => console.log(err));
// //   };

// //   useEffect(() => {
// //     if (user) getEventList();
// //   }, [user]);

// //   // 🛠️ Logic to detect room when selecting an issue in the dialog
// //   const handleIssueChange = (value) => {
// //     setSelectedIssue(value);
// //     const issueObj = issues.find(i => i.id === value);
// //     setSelectedIssueRoom(issueObj?.room_number || "");
// //   };

// //   const handleHourClick = (arg) => {
// //     if (!user) return;
// //     setOpen(true);

// //     let clickDate, clickTime;
// //     if (arg.dateStr) {
// //       const dt = new Date(arg.dateStr);
// //       clickDate = formatDate(dt);
// //       clickTime = dt;
// //     } else if (arg.date) {
// //       const dt = new Date(arg.date);
// //       clickDate = formatDate(dt);
// //       clickTime = dt;
// //     } else {
// //       clickDate = formatDate(arg);
// //       clickTime = arg;
// //     }

// //     setDate(clickDate);
// //     const start = clickTime;
// //     const end = new Date(start.getTime() + 30 * 60000);
// //     setStartTime(formatTime(start));
// //     setEndTime(formatTime(end));
// //   };

// //   const handleClose = () => {
// //     setOpen(false);
// //     setSelectedIssue("");
// //     setSelectedTechnician("");
// //     setSelectedIssueRoom("");
// //     setStartTime("");
// //     setEndTime("");
// //   };

// //   const handleEventClick = (event) => {
// //     setOpenEditModal(true);
// //     setSelectedEventId(event?.event?.extendedProps?.appointmentId);
// //   };

// //   const handleSubmit = () => {
// //     if (!selectedIssue || !selectedTechnician || !startTime || !endTime || !date) {
// //       alert("Please fill out all required fields.");
// //       return;
// //     }

// //     const payload = {
// //       issue: Number(selectedIssue),
// //       technician: Number(selectedTechnician),
// //       appointment_date: date,
// //       appointment_start: startTime.length === 5 ? `${startTime}:00` : startTime,
// //       appointment_end: endTime.length === 5 ? `${endTime}:00` : endTime,
// //     };

// //     axiosClient
// //       .post("/api/appointments/", payload)
// //       .then(() => {
// //         getEventList();
// //         handleClose();
// //       })
// //       .catch((err) => {
// //         console.log(err);
// //         alert(err?.response?.data?.detail || "Failed to create appointment");
// //       });
// //   };

// //   return (
// //     <div>
// //       <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
// //         <Button variant="contained" onClick={handleSwitchView}>
// //           {view === "dayGridMonth" ? t("Switch to Daily Schedule") : t("Switch to Month View")}
// //         </Button>

// //         {view === "timeGridDay" && (
// //           <ToggleButtonGroup
// //             value={dayViewMode}
// //             exclusive
// //             onChange={handleDayViewModeChange}
// //             aria-label="day view mode"
// //           >
// //             <ToggleButton value="hourView">{t("Hour View")}</ToggleButton>
// //             <ToggleButton value="doctorView">{t("Doctor View")}</ToggleButton>
// //           </ToggleButtonGroup>
// //         )}
// //       </Box>

// //       {view === "dayGridMonth" ? (
// //         <DaysCalendar events={events} onDateClick={(arg) => { setCalendarView("timeGridDay"); setDate(arg.dateStr); }} onEventClick={handleEventClick} />
// //       ) : dayViewMode === "hourView" ? (
// //         <HoursCalendar events={events} onDateClick={handleHourClick} onEventClick={handleEventClick} date={date} />
// //       ) : (
// //         <DoctorDayView
// //           events={events}
// //           staffUsers={technicians}
// //           onDateClick={handleHourClick}
// //           onEventClick={handleEventClick}
// //           date={date}
// //         />
// //       )}

// //       <Dialog fullWidth open={open} onClose={handleClose}>
// //         <DialogTitle>{t("Add New Appointment")}</DialogTitle>
// //         <DialogContent>
// //           <FormControl fullWidth variant="outlined" sx={{ marginBottom: "1rem", mt: 1 }}>
// //             <InputLabel>{t("Select Technician")}</InputLabel>
// //             <Select
// //               value={selectedTechnician}
// //               onChange={(e) => setSelectedTechnician(e.target.value)}
// //               label={t("Select Technician")}
// //               required
// //             >
// //               {technicians.map((tech) => (
// //                 <MenuItem key={tech.id} value={tech.user}>
// //                   {tech.user_first_name} {tech.user_last_name}
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>

// //           <FormControl fullWidth variant="outlined" sx={{ marginBottom: "1rem" }}>
// //             <InputLabel>{t("Select Issue")}</InputLabel>
// //             <Select
// //               value={selectedIssue}
// //               onChange={(e) => handleIssueChange(e.target.value)}
// //               label={t("Select Issue")}
// //               required
// //             >
// //               {issues.map((iss) => (
// //                 <MenuItem key={iss.id} value={iss.id}>
// //                   #{iss.id} - {iss.title}
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>

// //           {/* 🆕 Room Display in Dialog */}
// //           {selectedIssueRoom && (
// //             <Alert severity="info" sx={{ mb: 2 }}>
// //               {t("Location")}: <strong>{selectedIssueRoom}</strong>
// //             </Alert>
// //           )}

// //           <TextField
// //             fullWidth
// //             type="time"
// //             label={t("Time of Appointment (start)")}
// //             variant="outlined"
// //             InputLabelProps={{ shrink: true }}
// //             value={startTime || ""}
// //             onChange={(e) => setStartTime(e.target.value)}
// //             sx={{ marginBottom: "1rem" }}
// //             required
// //           />

// //           <TextField
// //             fullWidth
// //             type="time"
// //             label={t("Time of Appointment (end)")}
// //             variant="outlined"
// //             InputLabelProps={{ shrink: true }}
// //             value={endTime || ""}
// //             onChange={(e) => setEndTime(e.target.value)}
// //             sx={{ marginBottom: "1rem" }}
// //             required
// //           />
// //         </DialogContent>

// //         <DialogActions>
// //           <Button onClick={handleClose} color="primary">{t("Cancel")}</Button>
// //           <Button onClick={handleSubmit} color="primary">{t("Submit")}</Button>
// //         </DialogActions>
// //       </Dialog>

// //       <AppointmentEditModal
// //         open={openEditModal}
// //         id={selectedEventId}
// //         handleClose={handleEditModalClose}
// //         refresh={getEventList}
// //       />
// //     </div>
// //   );
// // }

// // // export default FullCalendarApp;

// //////////////////////////////



// import { useState, useEffect } from "react";
// import Button from "@mui/material/Button";
// import DaysCalendar from "./DaysCalendar";
// import HoursCalendar from "./HoursCalendar";
// import DoctorDayView from "./DoctorDayView";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import AppointmentEditModal from "./AppointmentEditModal";
// import {
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   TextField,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Box,
//   ToggleButtonGroup,
//   ToggleButton,
//   Alert,
//   Typography
// } from "@mui/material";
// import { useTranslation } from "react-i18next";

// function FullCalendarApp() {
//   const [view, setCalendarView] = useState("dayGridMonth");
//   const [dayViewMode, setDayViewMode] = useState("hourView");
//   const [events, setEvents] = useState([]);
//   const [open, setOpen] = useState(false);

//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [selectedEventId, setSelectedEventId] = useState(null);

//   const [date, setDate] = useState("");
//   const [startTime, setStartTime] = useState("");
//   const [endTime, setEndTime] = useState("");

//   const { t } = useTranslation();
//   const { user } = useStateContext();

//   const [staffMembers, setStaffMembers] = useState([]); 
//   const [issues, setIssues] = useState([]);
//   const [selectedStaff, setSelectedStaff] = useState(""); 
//   const [selectedIssue, setSelectedIssue] = useState("");
//   const [selectedIssueRoom, setSelectedIssueRoom] = useState("");

//   const formatTime = (d) => {
//     const hours = String(d.getHours()).padStart(2, "0");
//     const minutes = String(d.getMinutes()).padStart(2, "0");
//     return `${hours}:${minutes}`;
//   };

//   const formatDate = (d) => {
//     const year = d.getFullYear();
//     const month = String(d.getMonth() + 1).padStart(2, "0");
//     const day = String(d.getDate()).padStart(2, "0");
//     return `${year}-${month}-${day}`;
//   };

//   const handleSwitchView = () => {
//     setCalendarView(view === "dayGridMonth" ? "timeGridDay" : "dayGridMonth");
//   };

//   const handleDayViewModeChange = (event, newMode) => {
//     if (newMode !== null) setDayViewMode(newMode);
//   };

//   const handleEditModalClose = () => setOpenEditModal(false);

//   useEffect(() => {
//     if (!user) return;

//     Promise.all([
//       axiosClient.get("/auth/technicians/"), 
//       axiosClient.get("/api/issues/"),
//     ])
//       .then(([staffRes, issueRes]) => {
//         setStaffMembers(staffRes.data || []);
//         setIssues(issueRes.data || []);
//       })
//       .catch((err) => console.log(err));
//   }, [user]);

//   const getEventList = () => {
//     axiosClient
//       .get("/api/appointments/")
//       .then((res) => {
//         const data = res.data || [];
//         const transformed = data.map((a) => {
//           const issueTitle = a.issue_info?.title || `Issue #${a.issue}`;
//           const room = a.issue_info?.room_number ? ` [Room: ${a.issue_info.room_number}]` : "";
          
//           const staffName =
//             a.technician_info
//               ? `${a.technician_info.first_name || ""} ${a.technician_info.last_name || ""}`.trim()
//               : `Staff #${a.technician}`;

//           return {
//             title: `${issueTitle} (${staffName})${room}`,
//             start: `${a.appointment_date}T${a.appointment_start}`,
//             end: `${a.appointment_date}T${a.appointment_end}`,
//             appointmentId: a.id,
//             id: a.id,
//             extendedProps: { room_number: a.issue_info?.room_number }
//           };
//         });
//         setEvents(transformed);
//       })
//       .catch((err) => console.log(err));
//   };

//   useEffect(() => {
//     if (user) getEventList();
//   }, [user]);

//   const handleIssueChange = (value) => {
//     setSelectedIssue(value);
//     const issueObj = issues.find(i => i.id === value);
//     setSelectedIssueRoom(issueObj?.room_number || "");
//   };

//   const handleHourClick = (arg) => {
//     if (!user) return;
//     setOpen(true);

//     let clickDate, clickTime;
//     if (arg.dateStr) {
//       const dt = new Date(arg.dateStr);
//       clickDate = formatDate(dt);
//       clickTime = dt;
//     } else if (arg.date) {
//       const dt = new Date(arg.date);
//       clickDate = formatDate(dt);
//       clickTime = dt;
//     } else {
//       clickDate = formatDate(arg);
//       clickTime = arg;
//     }

//     setDate(clickDate);
//     const start = clickTime;
//     const end = new Date(start.getTime() + 30 * 60000);
//     setStartTime(formatTime(start));
//     setEndTime(formatTime(end));
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setSelectedIssue("");
//     setSelectedStaff("");
//     setSelectedIssueRoom("");
//     setStartTime("");
//     setEndTime("");
//   };

//   const handleEventClick = (event) => {
//     setOpenEditModal(true);
//     setSelectedEventId(event?.event?.extendedProps?.appointmentId);
//   };

//   const handleSubmit = () => {
//     if (!selectedIssue || !selectedStaff || !startTime || !endTime || !date) {
//       alert(t("Please fill out all required fields."));
//       return;
//     }

//     const payload = {
//       issue: Number(selectedIssue),
//       technician: Number(selectedStaff), 
//       appointment_date: date,
//       appointment_start: startTime.length === 5 ? `${startTime}:00` : startTime,
//       appointment_end: endTime.length === 5 ? `${endTime}:00` : endTime,
//     };

//     axiosClient
//       .post("/api/appointments/", payload)
//       .then(() => {
//         getEventList();
//         handleClose();
//       })
//       .catch((err) => {
//         console.log(err);
//         alert(err?.response?.data?.detail || t("Failed to create appointment"));
//       });
//   };

//   return (
//     <div>
//       <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
//         <Button variant="contained" onClick={handleSwitchView}>
//           {view === "dayGridMonth" ? t("Switch to Daily Schedule") : t("Switch to Month View")}
//         </Button>

//         {view === "timeGridDay" && (
//           <ToggleButtonGroup
//             value={dayViewMode}
//             exclusive
//             onChange={handleDayViewModeChange}
//             aria-label="day view mode"
//           >
//             <ToggleButton value="hourView">{t("Hour View")}</ToggleButton>
//             <ToggleButton value="doctorView">{t("Doctor View")}</ToggleButton>
//           </ToggleButtonGroup>
//         )}
//       </Box>

//       {view === "dayGridMonth" ? (
//         <DaysCalendar events={events} onDateClick={(arg) => { setCalendarView("timeGridDay"); setDate(arg.dateStr); }} onEventClick={handleEventClick} />
//       ) : dayViewMode === "hourView" ? (
//         <HoursCalendar events={events} onDateClick={handleHourClick} onEventClick={handleEventClick} date={date} />
//       ) : (
//         <DoctorDayView
//           events={events}
//           staffUsers={staffMembers}
//           onDateClick={handleHourClick}
//           onEventClick={handleEventClick}
//           date={date}
//         />
//       )}

//       <Dialog fullWidth open={open} onClose={handleClose}>
//         <DialogTitle sx={{ fontWeight: 'bold' }}>{t("ADD TO CALENDAR")}</DialogTitle>
//         <DialogContent dividers>
          
//           <FormControl fullWidth variant="outlined" sx={{ marginBottom: "1.5rem", mt: 1 }}>
//             <InputLabel id="staff-select-label">{t("Select Staff (Technician or Maid)")}</InputLabel>
//             <Select
//               labelId="staff-select-label"
//               value={selectedStaff}
//               onChange={(e) => setSelectedStaff(e.target.value)}
//               label={t("Select Staff (Technician or Maid)")}
//               required
//             >
//               {staffMembers.map((staff) => (
//                 <MenuItem key={staff.id} value={staff.user}>
//                   <Box display="flex" justifyContent="space-between" width="100%" alignItems="center">
//                     <Typography>
//                       {staff.user_first_name} {staff.user_last_name}
//                     </Typography>
//                     {/* DYNAMIC ROLE REPLACEMENT FOR (DOCTOR) */}
//                     <Typography variant="caption" color="textSecondary" sx={{ fontStyle: 'italic', ml: 2 }}>
//                       ({staff.user_role || t("Staff")})
//                     </Typography>
//                   </Box>
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           <FormControl fullWidth variant="outlined" sx={{ marginBottom: "1.5rem" }}>
//             <InputLabel id="issue-select-label">{t("Select Issue")}</InputLabel>
//             <Select
//               labelId="issue-select-label"
//               value={selectedIssue}
//               onChange={(e) => handleIssueChange(e.target.value)}
//               label={t("Select Issue")}
//               required
//             >
//               {issues.map((iss) => (
//                 <MenuItem key={iss.id} value={iss.id}>
//                   #{iss.id} - {iss.title}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           {selectedIssueRoom && (
//             <Alert severity="info" sx={{ mb: 2 }}>
//               {t("Location")}: <strong>{selectedIssueRoom}</strong>
//             </Alert>
//           )}

//           <TextField
//             fullWidth
//             type="time"
//             label={t("TIME OF APPOINTMENT (START) *")}
//             variant="outlined"
//             InputLabelProps={{ shrink: true }}
//             value={startTime || ""}
//             onChange={(e) => setStartTime(e.target.value)}
//             sx={{ marginBottom: "1.5rem" }}
//             required
//           />

//           <TextField
//             fullWidth
//             type="time"
//             label={t("TIME OF APPOINTMENT (END) *")}
//             variant="outlined"
//             InputLabelProps={{ shrink: true }}
//             value={endTime || ""}
//             onChange={(e) => setEndTime(e.target.value)}
//             sx={{ marginBottom: "1rem" }}
//             required
//           />
//         </DialogContent>

//         <DialogActions sx={{ p: 2 }}>
//           <Button onClick={handleClose} variant="outlined">{t("CANCEL")}</Button>
//           <Button onClick={handleSubmit} variant="contained" color="primary">{t("SUBMIT")}</Button>
//         </DialogActions>
//       </Dialog>

//       <AppointmentEditModal
//         open={openEditModal}
//         id={selectedEventId}
//         handleClose={handleEditModalClose}
//         refresh={getEventList}
//       />
//     </div>
//   );
// }


///////////////////

// import { useState, useEffect } from "react";
// import Button from "@mui/material/Button";
// import DaysCalendar from "./DaysCalendar";
// import HoursCalendar from "./HoursCalendar";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import AppointmentEditModal from "./AppointmentEditModal";
// import {
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   TextField,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Box,
//   ToggleButtonGroup,
//   ToggleButton,
//   Alert,
//   Typography,
//   Chip 
// } from "@mui/material";
// import { useTranslation } from "react-i18next";

// function FullCalendarApp() {
//   const [view, setCalendarView] = useState("dayGridMonth");
//   const [dayViewMode, setDayViewMode] = useState("hourView");
//   const [events, setEvents] = useState([]);
//   const [open, setOpen] = useState(false);

//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [selectedEventId, setSelectedEventId] = useState(null);

//   const [date, setDate] = useState("");
//   const [startTime, setStartTime] = useState("");
//   const [endTime, setEndTime] = useState("");

//   const { t } = useTranslation();
//   const { user } = useStateContext();

//   const [staffMembers, setStaffMembers] = useState([]); 
//   const [issues, setIssues] = useState([]);
//   const [selectedStaff, setSelectedStaff] = useState(""); 
//   const [selectedIssue, setSelectedIssue] = useState("");
//   const [selectedIssueRoom, setSelectedIssueRoom] = useState("");

//   const formatTime = (d) => {
//     const hours = String(d.getHours()).padStart(2, "0");
//     const minutes = String(d.getMinutes()).padStart(2, "0");
//     return `${hours}:${minutes}`;
//   };

//   const formatDate = (d) => {
//     const year = d.getFullYear();
//     const month = String(d.getMonth() + 1).padStart(2, "0");
//     const day = String(d.getDate()).padStart(2, "0");
//     return `${year}-${month}-${day}`;
//   };

//   const handleSwitchView = () => {
//     setCalendarView(view === "dayGridMonth" ? "timeGridDay" : "dayGridMonth");
//   };

//   const handleDayViewModeChange = (event, newMode) => {
//     if (newMode !== null) setDayViewMode(newMode);
//   };

//   const handleEditModalClose = () => setOpenEditModal(false);

//   useEffect(() => {
//     if (!user) return;
//     Promise.all([
//       axiosClient.get("/auth/technicians/"), 
//       axiosClient.get("/api/issues/"),
//     ])
//       .then(([staffRes, issueRes]) => {
//         setStaffMembers(staffRes.data || []);
//         setIssues(issueRes.data || []);
//       })
//       .catch((err) => console.log(err));
//   }, [user]);

//   const getEventList = () => {
//     axiosClient
//       .get("/api/appointments/")
//       .then((res) => {
//         const data = res.data || [];
//         const transformed = data.map((a) => {
//           const issueTitle = a.issue_info?.title || `Issue #${a.issue}`;
//           const room = a.issue_info?.room_number ? ` [Room: ${a.issue_info.room_number}]` : "";
//           const staffName = a.technician_info
//               ? `${a.technician_info.first_name || ""} ${a.technician_info.last_name || ""}`.trim()
//               : `Staff #${a.technician}`;
//           return {
//             title: `${issueTitle} (${staffName})${room}`,
//             start: `${a.appointment_date}T${a.appointment_start}`,
//             end: `${a.appointment_date}T${a.appointment_end}`,
//             appointmentId: a.id,
//             id: a.id,
//             extendedProps: { room_number: a.issue_info?.room_number }
//           };
//         });
//         setEvents(transformed);
//       })
//       .catch((err) => console.log(err));
//   };

//   useEffect(() => {
//     if (user) getEventList();
//   }, [user]);

//   const handleIssueChange = (value) => {
//     setSelectedIssue(value);
//     const issueObj = issues.find(i => i.id === value);
//     setSelectedIssueRoom(issueObj?.room_number || "");
//   };

//   const handleHourClick = (arg) => {
//     if (!user) return;
//     setOpen(true);
//     let clickDate = formatDate(arg.date || arg);
//     setDate(clickDate);
//     let start = arg.date || arg;
//     let end = new Date(start.getTime() + 30 * 60000);
//     setStartTime(formatTime(start));
//     setEndTime(formatTime(end));
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setSelectedIssue("");
//     setSelectedStaff("");
//     setSelectedIssueRoom("");
//     setStartTime("");
//     setEndTime("");
//   };

//   const handleEventClick = (event) => {
//     setOpenEditModal(true);
//     setSelectedEventId(event?.event?.extendedProps?.appointmentId);
//   };

//   const handleSubmit = () => {
//     if (!selectedIssue || !selectedStaff || !startTime || !endTime || !date) {
//       alert(t("Please fill out all required fields."));
//       return;
//     }
//     const payload = {
//       issue: Number(selectedIssue),
//       technician: Number(selectedStaff), 
//       appointment_date: date,
//       appointment_start: startTime.length === 5 ? `${startTime}:00` : startTime,
//       appointment_end: endTime.length === 5 ? `${endTime}:00` : endTime,
//     };
//     axiosClient
//       .post("/api/appointments/", payload)
//       .then(() => {
//         getEventList();
//         handleClose();
//       })
//       .catch((err) => {
//         alert(err?.response?.data?.detail || t("Failed to create appointment"));
//       });
//   };

//   return (
//     <div>
//       <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
//         <Button variant="contained" onClick={handleSwitchView}>
//           {view === "dayGridMonth" ? t("Switch to Daily Schedule") : t("Switch to Month View")}
//         </Button>
//       </Box>

//       {view === "dayGridMonth" ? (
//         <DaysCalendar events={events} onDateClick={(arg) => { setCalendarView("timeGridDay"); setDate(arg.dateStr); }} onEventClick={handleEventClick} />
//       ) : (
//         <HoursCalendar events={events} onDateClick={handleHourClick} onEventClick={handleEventClick} date={date} />
//       )}

//       <Dialog fullWidth open={open} onClose={handleClose}>
//         <DialogTitle sx={{ fontWeight: 'bold' }}>{t("ADD TO CALENDAR")}</DialogTitle>
//         <DialogContent dividers>
          
//           <FormControl fullWidth variant="outlined" sx={{ marginBottom: "1.5rem", mt: 1 }}>
//             <InputLabel id="staff-select-label">{t("Select Staff (Technician or Maid)")}</InputLabel>
//             <Select
//               labelId="staff-select-label"
//               value={selectedStaff}
//               onChange={(e) => setSelectedStaff(e.target.value)}
//               label={t("Select Staff (Technician or Maid)")}
//               required
//               renderValue={(selected) => {
//                 const staff = staffMembers.find((s) => s.user === selected);
//                 if (!staff) return "";
//                 return `${staff.user_first_name} ${staff.user_last_name}`;
//               }}
//             >
//               {staffMembers.map((staff) => {
//                 // 🛠️ ROBUST ROLE DETECTION: Tries multiple keys to find the role
//                 const rawRole = staff.user_role || staff.role || (staff.user_info && staff.user_info.user_role);
//                 const isTech = String(rawRole).toUpperCase() === "TECHNICIAN";

//                 return (
//                   <MenuItem key={staff.id} value={staff.user}>
//                     <Box display="flex" justifyContent="space-between" width="100%" alignItems="center">
//                       <Typography>
//                         {staff.user_first_name} {staff.user_last_name}
//                       </Typography>
                      
//                       <Chip 
//                         label={isTech ? "TECHNICIAN" : "MAID"} 
//                         size="small" 
//                         variant="outlined" 
//                         sx={{ 
//                           ml: 2, 
//                           fontSize: '0.65rem', 
//                           fontWeight: 'bold',
//                           height: '20px',
//                           color: isTech ? "#2196f3" : "#e91e63",
//                           borderColor: isTech ? "#2196f3" : "#e91e63",
//                           borderRadius: '4px'
//                         }} 
//                       />
//                     </Box>
//                   </MenuItem>
//                 );
//               })}
//             </Select>
//           </FormControl>

//           <FormControl fullWidth variant="outlined" sx={{ marginBottom: "1.5rem" }}>
//             <InputLabel id="issue-select-label">{t("Select Issue")}</InputLabel>
//             <Select
//               labelId="issue-select-label"
//               value={selectedIssue}
//               onChange={(e) => handleIssueChange(e.target.value)}
//               label={t("Select Issue")}
//               required
//             >
//               {issues.map((iss) => (
//                 <MenuItem key={iss.id} value={iss.id}>
//                   #{iss.id} - {iss.title}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           {selectedIssueRoom && (
//             <Alert severity="info" sx={{ mb: 2 }}>
//               {t("Location")}: <strong>{selectedIssueRoom}</strong>
//             </Alert>
//           )}

//           <TextField
//             fullWidth
//             type="time"
//             label={t("TIME OF APPOINTMENT (START) *")}
//             variant="outlined"
//             InputLabelProps={{ shrink: true }}
//             value={startTime || ""}
//             onChange={(e) => setStartTime(e.target.value)}
//             sx={{ marginBottom: "1.5rem" }}
//             required
//           />

//           <TextField
//             fullWidth
//             type="time"
//             label={t("TIME OF APPOINTMENT (END) *")}
//             variant="outlined"
//             InputLabelProps={{ shrink: true }}
//             value={endTime || ""}
//             onChange={(e) => setEndTime(e.target.value)}
//             sx={{ marginBottom: "1rem" }}
//             required
//           />
//         </DialogContent>

//         <DialogActions sx={{ p: 2 }}>
//           <Button onClick={handleClose} variant="outlined">{t("CANCEL")}</Button>
//           <Button onClick={handleSubmit} variant="contained" color="primary">{t("SUBMIT")}</Button>
//         </DialogActions>
//       </Dialog>

//       <AppointmentEditModal
//         open={openEditModal}
//         id={selectedEventId}
//         handleClose={handleEditModalClose}
//         refresh={getEventList}
//       />
//     </div>
//   );
// }

// export default FullCalendarApp;


// import { useState, useEffect } from "react";
// import Button from "@mui/material/Button";
// import DaysCalendar from "./DaysCalendar";
// import HoursCalendar from "./HoursCalendar";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import AppointmentEditModal from "./AppointmentEditModal";
// import {
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   TextField,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Box,
//   Typography,
//   Chip,
//   Grid
// } from "@mui/material";
// import { useTranslation } from "react-i18next";

// function FullCalendarApp() {
//   const [view, setCalendarView] = useState("dayGridMonth");
//   const [events, setEvents] = useState([]);
//   const [open, setOpen] = useState(false);
//   const [selectedEventId, setSelectedEventId] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);

//   // Form States for the Modal
//   const [date, setDate] = useState("");
//   const [startTime, setStartTime] = useState("09:00");
//   const [endTime, setEndTime] = useState("10:00");
//   const [selectedStaff, setSelectedStaff] = useState("");
//   const [selectedIssue, setSelectedIssue] = useState("");
//   const [roomDisplay, setRoomDisplay] = useState("");

//   const { t } = useTranslation();
//   const { user } = useStateContext();

//   const [staffList, setStaffList] = useState([]);
//   const [issuesList, setIssuesList] = useState([]);

//   // 🛠️ 1. FETCH STAFF & ISSUES (Unified Logic)
//   useEffect(() => {
//     if (!user) return;
//     Promise.all([
//       axiosClient.get("auth/users/"), 
//       axiosClient.get("api/issues/")
//     ])
//       .then(([userRes, issueRes]) => {
//         const allUsers = Array.isArray(userRes.data) ? userRes.data : (userRes.data.results || []);
//         const assignable = allUsers.filter(u => 
//           u.user_role === "TECHNICIAN" || u.user_role === "MAID"
//         );
//         setStaffList(assignable);
//         setIssuesList(issueRes.data.results || issueRes.data || []);
//       })
//       .catch((err) => console.error("Fetch Error:", err));
//   }, [user]);

//   // 🛠️ 2. FETCH EVENTS (Sync Appointments AND Issues to Calendar)
//   const getEventList = async () => {
//     try {
//       const [apptRes, issueRes] = await Promise.all([
//         axiosClient.get("/api/appointments/"),
//         axiosClient.get("/api/issues/") // Fetching issues to show on calendar
//       ]);

//       // Transform Appointments
//       const apptEvents = (apptRes.data || []).map((a) => ({
//         id: `appt-${a.id}`,
//         title: `${a.issue_info?.title || 'Appt'} (${a.technician_info?.first_name || 'Staff'})`,
//         start: `${a.appointment_date}T${a.appointment_start}`,
//         end: `${a.appointment_date}T${a.appointment_end}`,
//         backgroundColor: "#2196f3", // Blue for appointments
//       }));

//       // Transform Issues into Calendar Events
//       const issueEvents = (issueRes.data || []).map((issue) => ({
//         id: `issue-${issue.id}`,
//         title: `${issue.title} (${issue.staff_name || 'Unassigned'}) [Room: ${issue.room_number}]`,
//         // Use created_at (Start Date/Time) for the calendar position
//         start: issue.appt_start || issue.created_at, 
//         end: issue.closed_at || issue.appt_end || null,
//         backgroundColor: "#e91e63", // Pink/Orange for issues to distinguish them
//       }));

//       setEvents([...apptEvents, ...issueEvents]);
//     } catch (err) {
//       console.error("Calendar Sync Error:", err);
//     }
//   };

//   useEffect(() => { if (user) getEventList(); }, [user]);

//   const handleIssueChange = (value) => {
//     setSelectedIssue(value);
//     const selectedObj = issuesList.find(i => String(i.id) === String(value));
//     setRoomDisplay(selectedObj?.room_number || selectedObj?.room || t("Not specified"));
//   };

//   const handleHourClick = (arg) => {
//     setOpen(true);
//     const dt = arg.date || new Date(arg.dateStr || arg);
//     setDate(dt.toISOString().split('T')[0]);
//     setStartTime(dt.toTimeString().slice(0, 5));
//   };

//   const handleSubmit = () => {
//     const payload = {
//       issue: Number(selectedIssue),
//       technician: Number(selectedStaff), 
//       appointment_date: date,
//       appointment_start: `${startTime}:00`,
//       appointment_end: `${endTime}:00`,
//     };
//     axiosClient.post("/api/appointments/", payload).then(() => {
//       getEventList();
//       setOpen(false);
//     });
//   };

//   return (
//     <div>
//       <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
//         <Button variant="contained" onClick={() => setCalendarView(view === "dayGridMonth" ? "timeGridDay" : "dayGridMonth")}>
//           {view === "dayGridMonth" ? t("Switch to Daily Schedule") : t("Switch to Month View")}
//         </Button>
//       </Box>

//       {view === "dayGridMonth" ? (
//         <DaysCalendar events={events} onDateClick={(arg) => { setCalendarView("timeGridDay"); setDate(arg.dateStr); }} onEventClick={(info) => { setSelectedEventId(info.event.id); setOpenEditModal(true); }} />
//       ) : (
//         <HoursCalendar events={events} onDateClick={handleHourClick} onEventClick={(info) => { setSelectedEventId(info.event.id); setOpenEditModal(true); }} date={date} />
//       )}

//       {/* ✅ MODAL WITH PROPER ROLES AND SYNC */}
//       <Dialog fullWidth maxWidth="sm" open={open} onClose={() => setOpen(false)}>
//         <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>{t("ADD TO CALENDAR")}</DialogTitle>
//         <DialogContent dividers>
//           <Grid container spacing={2} sx={{ mt: 1 }}>
//             <Grid item xs={12}>
//               <FormControl fullWidth>
//                 <InputLabel>{t("Select Staff")}</InputLabel>
//                 <Select value={selectedStaff} label={t("Select Staff")} onChange={(e) => setSelectedStaff(e.target.value)}>
//                   {staffList.map((staff) => (
//                     <MenuItem key={staff.id} value={staff.id}>
//                       <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
//                         <Typography>{staff.first_name} {staff.last_name}</Typography>
//                         {/* ✅ Correct Role Logic from CreateIssue */}
//                         <Chip 
//                           label={staff.user_role} 
//                           size="small" 
//                           variant="outlined" 
//                           sx={{ 
//                             color: staff.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63",
//                             borderColor: staff.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63"
//                           }} 
//                         />
//                       </Box>
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12}>
//               <FormControl fullWidth>
//                 <InputLabel>{t("Select Issue")}</InputLabel>
//                 <Select value={selectedIssue} label={t("Select Issue")} onChange={(e) => handleIssueChange(e.target.value)}>
//                   {issuesList.map(i => <MenuItem key={i.id} value={i.id}>#{i.id} - {i.title}</MenuItem>)}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12}>
//               <TextField fullWidth label={t("ROOM")} value={roomDisplay} InputProps={{ readOnly: true }} variant="filled" />
//             </Grid>

//             <Grid item xs={6}><TextField fullWidth label={t("START")} type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} InputLabelProps={{ shrink: true }} /></Grid>
//             <Grid item xs={6}><TextField fullWidth label={t("END")} type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} InputLabelProps={{ shrink: true }} /></Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button onClick={() => setOpen(false)}>{t("CANCEL")}</Button>
//           <Button variant="contained" onClick={handleSubmit}>{t("SUBMIT")}</Button>
//         </DialogActions>
//       </Dialog>

//       <AppointmentEditModal open={openEditModal} id={selectedEventId} handleClose={() => setOpenEditModal(false)} refresh={getEventList} />
//     </div>
//   );
// }

// export default FullCalendarApp;



////////////////////////////////

// import { useState, useEffect } from "react";
// import Button from "@mui/material/Button";
// import DaysCalendar from "./DaysCalendar";
// import HoursCalendar from "./HoursCalendar";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import AppointmentEditModal from "./AppointmentEditModal";
// import {
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   TextField,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Box,
//   Typography,
//   Chip,
//   Grid
// } from "@mui/material";
// import { useTranslation } from "react-i18next";

// function FullCalendarApp() {
//   const [view, setCalendarView] = useState("dayGridMonth");
//   const [events, setEvents] = useState([]);
//   const [open, setOpen] = useState(false);
//   const [selectedEventId, setSelectedEventId] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);

//   // Form States for the Modal
//   const [date, setDate] = useState("");
//   const [startTime, setStartTime] = useState("09:00");
//   const [endTime, setEndTime] = useState("10:00");
//   const [selectedStaff, setSelectedStaff] = useState("");
//   const [selectedIssue, setSelectedIssue] = useState("");
//   const [roomDisplay, setRoomDisplay] = useState("");

//   const { t } = useTranslation();
//   const { user } = useStateContext();

//   const [staffList, setStaffList] = useState([]);
//   const [issuesList, setIssuesList] = useState([]);

//   useEffect(() => {
//     if (!user) return;
//     Promise.all([
//       axiosClient.get("auth/users/"), 
//       axiosClient.get("api/issues/")
//     ])
//       .then(([userRes, issueRes]) => {
//         const allUsers = Array.isArray(userRes.data) ? userRes.data : (userRes.data.results || []);
//         const assignable = allUsers.filter(u => 
//           u.user_role === "TECHNICIAN" || u.user_role === "MAID"
//         );
//         setStaffList(assignable);
//         setIssuesList(issueRes.data.results || issueRes.data || []);
//       })
//       .catch((err) => console.error("Fetch Error:", err));
//   }, [user]);

//   const getEventList = async () => {
//     try {
//       const [apptRes, issueRes] = await Promise.all([
//         axiosClient.get("/api/appointments/"),
//         axiosClient.get("/api/issues/")
//       ]);

//       const apptEvents = (apptRes.data || []).map((a) => ({
//         id: `appt-${a.id}`,
//         title: `${a.issue_info?.title || 'Appt'} (${a.technician_info?.first_name || 'Staff'})`,
//         start: `${a.appointment_date}T${a.appointment_start}`,
//         end: `${a.appointment_date}T${a.appointment_end}`,
//         backgroundColor: "#2196f3",
//       }));

//       const issueEvents = (issueRes.data || []).map((issue) => ({
//         id: `issue-${issue.id}`,
//         title: `${issue.title} (${issue.staff_name || 'Unassigned'}) [Room: ${issue.room_number}]`,
//         start: issue.appt_start || issue.created_at, 
//         end: issue.closed_at || issue.appt_end || null,
//         backgroundColor: "#e91e63",
//       }));

//       setEvents([...apptEvents, ...issueEvents]);
//     } catch (err) {
//       console.error("Calendar Sync Error:", err);
//     }
//   };

//   useEffect(() => { if (user) getEventList(); }, [user]);

//   const handleIssueChange = (value) => {
//     setSelectedIssue(value);
//     const selectedObj = issuesList.find(i => String(i.id) === String(value));
//     setRoomDisplay(selectedObj?.room_number || selectedObj?.room || t("Not specified"));
//   };

//   // 🛠️ NEW LOGIC: This handles clicks from both the Month view and the Button
//   const handleOpenAddModal = (arg) => {
//     setOpen(true);
//     // If it's a date click from the month view, set that date
//     if (arg && (arg.dateStr || arg.date)) {
//       const dt = arg.date || new Date(arg.dateStr);
//       setDate(arg.dateStr || dt.toISOString().split('T')[0]);
//     }
//   };

//   const handleSubmit = () => {
//     const payload = {
//       issue: Number(selectedIssue),
//       technician: Number(selectedStaff), 
//       appointment_date: date,
//       appointment_start: `${startTime}:00`,
//       appointment_end: `${endTime}:00`,
//     };
//     axiosClient.post("/api/appointments/", payload).then(() => {
//       getEventList();
//       setOpen(false);
//       // Optional: Reset form fields here
//     });
//   };

//   return (
//     <div>
//       <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
//         {/* 🛠️ Bypassing the Daily view and going straight to the Modal */}
//         <Button variant="contained" onClick={() => handleOpenAddModal()}>
//           {t("Add Appointment")}
//         </Button>
//       </Box>

//       {/* 🛠️ Simplified: Removed HoursCalendar switching logic */}
//       <DaysCalendar 
//         events={events} 
//         onDateClick={handleOpenAddModal} // Now opens modal directly instead of switching view
//         onEventClick={(info) => { setSelectedEventId(info.event.id); setOpenEditModal(true); }} 
//       />

//       <Dialog fullWidth maxWidth="sm" open={open} onClose={() => setOpen(false)}>
//         <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>{t("ADD TO CALENDAR")}</DialogTitle>
//         <DialogContent dividers>
//           <Grid container spacing={2} sx={{ mt: 1 }}>
//             {/* Added Date picker inside modal just in case they want to change it */}
//             <Grid item xs={12}>
//                 <TextField 
//                     fullWidth 
//                     label={t("DATE")} 
//                     type="date" 
//                     value={date} 
//                     onChange={(e) => setDate(e.target.value)} 
//                     InputLabelProps={{ shrink: true }} 
//                 />
//             </Grid>

//             <Grid item xs={12}>
//               <FormControl fullWidth>
//                 <InputLabel>{t("Select Staff")}</InputLabel>
//                 <Select value={selectedStaff} label={t("Select Staff")} onChange={(e) => setSelectedStaff(e.target.value)}>
//                   {staffList.map((staff) => (
//                     <MenuItem key={staff.id} value={staff.id}>
//                       <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
//                         <Typography>{staff.first_name} {staff.last_name}</Typography>
//                         <Chip 
//                           label={staff.user_role} 
//                           size="small" 
//                           variant="outlined" 
//                           sx={{ 
//                             color: staff.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63",
//                             borderColor: staff.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63"
//                           }} 
//                         />
//                       </Box>
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12}>
//               <FormControl fullWidth>
//                 <InputLabel>{t("Select Issue")}</InputLabel>
//                 <Select value={selectedIssue} label={t("Select Issue")} onChange={(e) => handleIssueChange(e.target.value)}>
//                   {issuesList.map(i => <MenuItem key={i.id} value={i.id}>#{i.id} - {i.title}</MenuItem>)}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12}>
//               <TextField fullWidth label={t("ROOM")} value={roomDisplay} InputProps={{ readOnly: true }} variant="filled" />
//             </Grid>

//             <Grid item xs={6}><TextField fullWidth label={t("START")} type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} InputLabelProps={{ shrink: true }} /></Grid>
//             <Grid item xs={6}><TextField fullWidth label={t("END")} type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} InputLabelProps={{ shrink: true }} /></Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button onClick={() => setOpen(false)}>{t("CANCEL")}</Button>
//           <Button variant="contained" onClick={handleSubmit}>{t("SUBMIT")}</Button>
//         </DialogActions>
//       </Dialog>

//       <AppointmentEditModal open={openEditModal} id={selectedEventId} handleClose={() => setOpenEditModal(false)} refresh={getEventList} />
//     </div>
//   );
// }

// export default FullCalendarApp;

///////////////////////
// import { useState, useEffect } from "react";
// import Button from "@mui/material/Button";
// import DaysCalendar from "./DaysCalendar";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import AppointmentEditModal from "./AppointmentEditModal";
// import {
//   Box,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button as MuiButton,
//   Typography
// } from "@mui/material";
// import { useTranslation } from "react-i18next";

// function FullCalendarApp() {
//   const [events, setEvents] = useState([]);
//   const [selectedEventId, setSelectedEventId] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);

//   const { t } = useTranslation();
//   // 🛠️ Added setView and setDate from context to handle navigation
//   const { user, setView, setDate } = useStateContext();

//   const getEventList = async () => {
//     try {
//       const [apptRes, issueRes] = await Promise.all([
//         axiosClient.get("/api/appointments/"),
//         axiosClient.get("/api/issues/")
//       ]);

//       const apptEvents = (apptRes.data || []).map((a) => ({
//         id: `appt-${a.id}`,
//         title: `${a.issue_info?.title || 'Appt'} (${a.technician_info?.first_name || 'Staff'})`,
//         start: `${a.appointment_date}T${a.appointment_start}`,
//         end: `${a.appointment_date}T${a.appointment_end}`,
//         backgroundColor: "#2196f3",
//       }));

//       const issueEvents = (issueRes.data || []).map((issue) => ({
//         id: `issue-${issue.id}`,
//         title: `${issue.title} (${issue.staff_name || 'Unassigned'}) [Room: ${issue.room_number}]`,
//         start: issue.appt_start || issue.created_at, 
//         end: issue.closed_at || issue.appt_end || null,
//         backgroundColor: "#e91e63",
//       }));

//       setEvents([...apptEvents, ...issueEvents]);
//     } catch (err) {
//       console.error("Calendar Sync Error:", err);
//     }
//   };

//   useEffect(() => { if (user) getEventList(); }, [user]);

//   // 🛠️ UPDATED LOGIC: Redirects to the Create Issue screen
//   const handleDateClick = (arg) => {
//     if (!user) return;

//     // 1. Save the clicked date to context so CreateIssue can read it
//     if (arg && (arg.dateStr || arg.date)) {
//       const selectedDate = arg.dateStr || new Date(arg.date).toISOString().split('T')[0];
//       setDate(selectedDate);
//     }

//     // 2. Change the view to "create_issue" (This renders the CreateIssue component)
//     setView("create_issue");
//   };

//   return (
//     <div>
//       <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
//         <Button variant="contained" onClick={() => setView("create_issue")}>
//           {t("Log New Issue")}
//         </Button>
//       </Box>

//       {/* Monthly View */}
//       <DaysCalendar 
//         events={events} 
//         onDateClick={handleDateClick} // Now redirects to full screen
//         onEventClick={(info) => { 
//           setSelectedEventId(info.event.id.split('-')[1]); 
//           setOpenEditModal(true); 
//         }} 
//       />

//       {/* Edit Modal remains for clicking existing events */}
//       <AppointmentEditModal 
//         open={openEditModal} 
//         id={selectedEventId} 
//         handleClose={() => setOpenEditModal(false)} 
//         refresh={getEventList} 
//       />
//     </div>
//   );
// }

// export default FullCalendarApp;

/////////////////////////

// import { useState, useEffect } from "react";
// import Button from "@mui/material/Button";
// import DaysCalendar from "./DaysCalendar";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import AppointmentEditModal from "./AppointmentEditModal";
// import {
//   Box,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button as MuiButton,
//   Typography
// } from "@mui/material";
// import { useTranslation } from "react-i18next";

// function FullCalendarApp() {
//   const [events, setEvents] = useState([]);
//   const [selectedEventId, setSelectedEventId] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);

//   const { t } = useTranslation();
//   const { user, setView, setDate } = useStateContext();

//   const getEventList = async () => {
//     try {
//       const [apptRes, issueRes] = await Promise.all([
//         axiosClient.get("/api/appointments/"),
//         axiosClient.get("/api/issues/")
//       ]);

//       // 1. Transform Appointments (Blue Events)
//       const apptEvents = (apptRes.data || []).map((a) => ({
//         id: `appt-${a.id}`,
//         title: `${a.issue_info?.title || 'Appt'} (${a.technician_info?.first_name || 'Staff'})`,
//         start: `${a.appointment_date}T${a.appointment_start}`,
//         end: `${a.appointment_date}T${a.appointment_end}`,
//         backgroundColor: "#2196f3", // Blue
//       }));

//       // 2. Transform Issues (Pink/Orange Events)
//       const issueEvents = (issueRes.data || []).map((issue) => {
//         // 🛠️ FIX: We must use the scheduled date (created_at field used as appt_start) 
//         // to ensure it shows on the correct day in the calendar.
//         // In your case, this is March 10th
//         const eventStart = issue.created_at || issue.appt_start;

//         return {
//           id: `issue-${issue.id}`,
//           title: `${issue.title} [Room: ${issue.room_number}] (${issue.staff_name || 'Unassigned'})`,
//           start: eventStart, 
//           end: issue.closed_at || issue.appt_end || null,
//           backgroundColor: "#e91e63", // Pink
//         };
//       });

//       setEvents([...apptEvents, ...issueEvents]);
//     } catch (err) {
//       console.error("Calendar Sync Error:", err);
//     }
//   };

//   useEffect(() => { if (user) getEventList(); }, [user]);

//   // Handle clicking an empty date cell
//   const handleDateClick = (arg) => {
//     if (!user) return;

//     if (arg && (arg.dateStr || arg.date)) {
//       const selectedDate = arg.dateStr || new Date(arg.date).toISOString().split('T')[0];
//       setDate(selectedDate);
//     }

//     // Redirect to the Log New Issue screen
//     setView("create_issue");
//   };

//   return (
//     <div>
//       <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
//         <Button variant="contained" onClick={() => setView("create_issue")}>
//           {t("Log New Issue")}
//         </Button>
//       </Box>

//       {/* Monthly View Grid */}
//       <DaysCalendar 
//         events={events} 
//         onDateClick={handleDateClick} 
//         onEventClick={(info) => { 
//           // Extract the numeric ID regardless of prefix (appt- or issue-)
//           const rawId = info.event.id.includes('-') 
//             ? info.event.id.split('-')[1] 
//             : info.event.id;
          
//           setSelectedEventId(rawId); 
//           setOpenEditModal(true); 
//         }} 
//       />

//       {/* Modal for editing/viewing existing calendar dots */}
//       <AppointmentEditModal 
//         open={openEditModal} 
//         id={selectedEventId} 
//         handleClose={() => setOpenEditModal(false)} 
//         refresh={getEventList} 
//       />
//     </div>
//   );
// }

// export default FullCalendarApp;


// import { useState, useEffect } from "react";
// import Button from "@mui/material/Button";
// import DaysCalendar from "./DaysCalendar";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import AppointmentEditModal from "./AppointmentEditModal";
// import { Box } from "@mui/material";
// import { useTranslation } from "react-i18next";

// function FullCalendarApp() {
//   const [events, setEvents] = useState([]);
//   const [selectedEventId, setSelectedEventId] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);

//   const { t } = useTranslation();
//   const { user, setView, setDate } = useStateContext();

//   const getEventList = async () => {
//     try {
//       const [apptRes, issueRes] = await Promise.all([
//         axiosClient.get("/api/appointments/"),
//         axiosClient.get("/api/issues/")
//       ]);

//       // 1. Transform Appointments (Blue Events)
//       const apptEvents = (apptRes.data || []).map((a) => ({
//         id: `appt-${a.id}`,
//         title: `${a.issue_info?.title || 'Appt'} (${a.technician_info?.first_name || 'Staff'})`,
//         start: `${a.appointment_date}T${a.appointment_start}`,
//         end: `${a.appointment_date}T${a.appointment_end}`,
//         backgroundColor: "#2196f3", 
//       }));

//       // 2. Transform Issues (Pink Events)
//       const issueEvents = (issueRes.data || []).map((issue) => {
        
//         // 🛠️ THE CRITICAL FIX: 
//         // We now use the scheduled_start field from your new backend model.
//         // This ensures the dot stays on the date you picked (e.g., March 10th).
//         const eventStart = issue.scheduled_start || issue.created_at;

//         return {
//           id: `issue-${issue.id}`,
//           title: `${issue.title} [Room: ${issue.room_number}]`,
//           start: eventStart, 
//           end: issue.closed_at || null,
//           backgroundColor: "#e91e63", 
//         };
//       });

//       setEvents([...apptEvents, ...issueEvents]);
//     } catch (err) {
//       console.error("Calendar Sync Error:", err);
//     }
//   };

//   useEffect(() => { if (user) getEventList(); }, [user]);

//   const handleDateClick = (arg) => {
//     if (!user) return;
//     if (arg && (arg.dateStr || arg.date)) {
//       const selectedDate = arg.dateStr || new Date(arg.date).toISOString().split('T')[0];
//       setDate(selectedDate);
//     }
//     setView("create_issue");
//   };

//   return (
//     <div>
//       <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
//         <Button variant="contained" onClick={() => setView("create_issue")}>
//           {t("Log New Issue")}
//         </Button>
//       </Box>

//       <DaysCalendar 
//         events={events} 
//         onDateClick={handleDateClick} 
//         onEventClick={(info) => { 
//           const rawId = info.event.id.includes('-') 
//             ? info.event.id.split('-')[1] 
//             : info.event.id;
          
//           setSelectedEventId(rawId); 
//           setOpenEditModal(true); 
//         }} 
//       />

//       <AppointmentEditModal 
//         open={openEditModal} 
//         id={selectedEventId} 
//         handleClose={() => setOpenEditModal(false)} 
//         refresh={getEventList} 
//       />
//     </div>
//   );
// }

// export default FullCalendarApp;

/////////////////////////////////////////////////////////////////////////


// import { useState, useEffect } from "react";
// import Button from "@mui/material/Button";
// import DaysCalendar from "./DaysCalendar";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import AppointmentEditModal from "./AppointmentEditModal";
// import { Box } from "@mui/material";
// import { useTranslation } from "react-i18next";

// function FullCalendarApp() {
//   const [events, setEvents] = useState([]);
//   const [selectedEventId, setSelectedEventId] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);

//   const { t } = useTranslation();
//   const { user, setView, setDate } = useStateContext();

//   const getEventList = async () => {
//     try {
//       const [apptRes, issueRes] = await Promise.all([
//         axiosClient.get("/api/appointments/"),
//         axiosClient.get("/api/issues/")
//       ]);

//       // 1. Transform Appointments (Blue Dots/Bars)
//       const apptEvents = (apptRes.data || []).map((a) => ({
//         id: `appt-${a.id}`,
//         title: `${a.issue_info?.title || 'Appt'} (${a.technician_info?.first_name || 'Staff'})`,
//         start: `${a.appointment_date}T${a.appointment_start}`,
//         end: `${a.appointment_date}T${a.appointment_end}`,
//         backgroundColor: "#2196f3", // Blue
//       }));

//       // 2. Transform Issues (Pink Bars)
//       const issueEvents = (issueRes.data || []).map((issue) => {
        
//         // 🛠️ LOGIC: Use the start and end dates calculated by your Serializer
//         // Start: creation or scheduled date
//         // End: closed_at date or timezone.now() (if open)
//         const eventStart = issue.appt_start;
//         const eventEnd = issue.appt_end;

//         return {
//           id: `issue-${issue.id}`,
//           title: `${issue.title} [Room: ${issue.room_number}]`,
//           start: eventStart, 
//           end: eventEnd,
//           backgroundColor: "#e91e63", // Pink
//           allDay: false, 
//           // Ensures the event renders as a solid bar spanning multiple days if open
//           display: 'block', 
//         };
//       });

//       setEvents([...apptEvents, ...issueEvents]);
//     } catch (err) {
//       console.error("Calendar Sync Error:", err);
//     }
//   };

//   useEffect(() => { if (user) getEventList(); }, [user]);

//   const handleDateClick = (arg) => {
//     if (!user) return;
//     if (arg && (arg.dateStr || arg.date)) {
//       const selectedDate = arg.dateStr || new Date(arg.date).toISOString().split('T')[0];
//       setDate(selectedDate);
//     }
//     setView("create_issue");
//   };

//   return (
//     <div>
//       <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
//         <Button variant="contained" onClick={() => setView("create_issue")}>
//           {t("Log New Issue")}
//         </Button>
//       </Box>

//       <DaysCalendar 
//         events={events} 
//         onDateClick={handleDateClick} 
//         onEventClick={(info) => { 
//           // Extract the numeric ID regardless of prefix (appt- or issue-)
//           const rawId = info.event.id.includes('-') 
//             ? info.event.id.split('-')[1] 
//             : info.event.id;
          
//           setSelectedEventId(rawId); 
//           setOpenEditModal(true); 
//         }} 
//       />

//       <AppointmentEditModal 
//         open={openEditModal} 
//         id={selectedEventId} 
//         handleClose={() => setOpenEditModal(false)} 
//         refresh={getEventList} 
//       />
//     </div>
//   );
// }

// export default FullCalendarApp;


////////////////////////////////////////////////////////////////////////////////


// import { useState, useEffect } from "react";
// import Button from "@mui/material/Button";
// import DaysCalendar from "./DaysCalendar";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import AppointmentEditModal from "./AppointmentEditModal";
// import { Box } from "@mui/material";

// function FullCalendarApp() {
//   const [events, setEvents] = useState([]);
//   const [selectedEventId, setSelectedEventId] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const { user, setView, setDate } = useStateContext();

//   const getEventList = async () => {
//     try {
//       const [apptRes, issueRes] = await Promise.all([
//         axiosClient.get("/api/appointments/"),
//         axiosClient.get("/api/issues/")
//       ]);

//       const issueEvents = (issueRes.data || []).map((issue) => {
//         const eventStart = issue.appt_start;
//         // 🛠️ THE FIX: If there is no end date, set end = start. 
//         // This stops the 11:43 PM event from stretching into the next day.
//         const eventEnd = issue.appt_end ? issue.appt_end : eventStart;

//         return {
//           id: `issue-${issue.id}`,
//           title: `${issue.title} [Room: ${issue.room_number}]`,
//           start: eventStart, 
//           end: eventEnd,
//           backgroundColor: "#e91e63",
//           allDay: false, 
//           display: 'block', 
//         };
//       });

//       setEvents([...issueEvents]);
//     } catch (err) { console.error(err); }
//   };

//   useEffect(() => { if (user) getEventList(); }, [user]);

//   return (
//     <div>
//       <Box sx={{ mb: 2 }}><Button variant="contained" onClick={() => setView("create_issue")}>Log New Issue</Button></Box>
//       <DaysCalendar 
//         events={events} 
//         onDateClick={(arg) => { setDate(arg.dateStr); setView("create_issue"); }} 
//         onEventClick={(info) => { setSelectedEventId(info.event.id.split('-')[1]); setOpenEditModal(true); }} 
//       />
//       <AppointmentEditModal open={openEditModal} id={selectedEventId} handleClose={() => setOpenEditModal(false)} refresh={getEventList} />
//     </div>
//   );
// }
// export default FullCalendarApp;

// ////////////////////////////////////////////////////////////////////////////////


// import { useState, useEffect } from "react";
// import Button from "@mui/material/Button";
// import DaysCalendar from "./DaysCalendar";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import AppointmentEditModal from "./AppointmentEditModal";
// import { Box } from "@mui/material";

// function FullCalendarApp() {
//   const [events, setEvents] = useState([]);
//   const [selectedEventId, setSelectedEventId] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const { user, setView, setDate } = useStateContext();

//   const getEventList = async () => {
//     try {
//       const [apptRes, issueRes] = await Promise.all([
//         axiosClient.get("/api/appointments/"),
//         axiosClient.get("/api/issues/")
//       ]);

//       const issueEvents = (issueRes.data || []).map((issue) => {
//         const eventStart = issue.appt_start;
//         // Fix for the 2-day stretch: if no end date, end = start
//         const eventEnd = issue.appt_end ? issue.appt_end : eventStart;

//         return {
//           id: `issue-${issue.id}`,
//           title: `${issue.title} [Room: ${issue.room_number}]`,
//           start: eventStart, 
//           end: eventEnd,
//           backgroundColor: "#e91e63",
//           allDay: false, 
//           display: 'block', 
//         };
//       });

//       setEvents([...issueEvents]);
//     } catch (err) { console.error(err); }
//   };

//   useEffect(() => { if (user) getEventList(); }, [user]);

//   return (
//     <div>
//       <Box sx={{ mb: 2 }}>
//         <Button variant="contained" onClick={() => setView("create_issue")}>
//           Log New Issue
//         </Button>
//       </Box>
//       <DaysCalendar 
//         events={events} 
//         onDateClick={(arg) => { 
//           setDate(arg.dateStr); 
//           setView("create_issue"); 
//         }} 
//         onEventClick={(info) => { 
//           setSelectedEventId(info.event.id.split('-')[1]); 
//           setOpenEditModal(true); 
//         }} 
//       />
//       <AppointmentEditModal 
//         open={openEditModal} 
//         id={selectedEventId} 
//         handleClose={() => setOpenEditModal(false)} 
//         refresh={getEventList} 
//       />
//     </div>
//   );
// }
// export default FullCalendarApp;


//////////////////////////////////////



// import { useState, useEffect, useCallback } from "react";
// import Button from "@mui/material/Button";
// import DaysCalendar from "./DaysCalendar";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import AppointmentEditModal from "./AppointmentEditModal";
// import { 
//   Box, Dialog, DialogTitle, DialogContent, 
//   DialogActions, TextField, Stack, Typography 
// } from "@mui/material";

// function FullCalendarApp() {
//   const [events, setEvents] = useState([]);
//   const [selectedEventId, setSelectedEventId] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);
  
//   // States for the simplified Resolve Modal (Maid/Tech)
//   const [openResolveModal, setOpenResolveModal] = useState(false);
//   const [resolveData, setResolveData] = useState({ endTime: '', comment: '' });

//   const { user, setView, setDate } = useStateContext();

//   const getEventList = useCallback(async () => {
//     try {
//       const [apptRes, issueRes] = await Promise.all([
//         axiosClient.get("/api/appointments/"),
//         axiosClient.get("/api/issues/")
//       ]);

//       const issueEvents = (issueRes.data || []).map((issue) => {
//         const eventStart = issue.appt_start;
//         const eventEnd = issue.appt_end ? issue.appt_end : eventStart;

//         return {
//           id: `issue-${issue.id}`, // FullCalendar internal ID
//           title: `${issue.title} [Room: ${issue.room_number}]`,
//           start: eventStart, 
//           end: eventEnd,
//           backgroundColor: issue.status === 'closed' ? '#4caf50' : '#e91e63', // Green if closed, Pink if open
//           allDay: false, 
//           display: 'block', 
//         };
//       });

//       setEvents([...issueEvents]);
//     } catch (err) { 
//       console.error("Error loading events:", err); 
//     }
//   }, []);

//   useEffect(() => { 
//     if (user) getEventList(); 
//   }, [user, getEventList]);

//   // 🛠️ HANDLER FOR SUBMITTING RESOLUTION (TECH/MAID)
//   const handleResolveSubmit = async () => {
//     try {
//       // 🛡️ CRITICAL FIX: Ensure we strip the "issue-" prefix before sending to backend
//       const cleanId = selectedEventId.toString().replace('issue-', '');
      
//       await axiosClient.post(`/api/close-issue/${cleanId}/`, {
//         end_time: resolveData.endTime,
//         comment: resolveData.comment
//       });
      
//       setOpenResolveModal(false);
//       getEventList(); // Refresh the calendar UI
//       alert("Task successfully closed and time recorded.");
//     } catch (err) {
//       console.error("Submission Error:", err.response?.data);
//       alert("Error: " + (err.response?.data?.error || "Failed to close task"));
//     }
//   };

//   return (
//     <div>
//       <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//         <Typography variant="h5" fontWeight="bold">
//           {user?.user_role === "ADMIN" ? "Hotel Calendar" : "My Tasks Calendar"}
//         </Typography>
//         {(user?.user_role === "ADMIN" || user?.user_role === "RECEPTION") && (
//             <Button variant="contained" onClick={() => setView("create_issue")}>
//                 Log New Issue
//             </Button>
//         )}
//       </Box>

//       <DaysCalendar 
//         events={events} 
//         onDateClick={(arg) => { 
//           if (user?.user_role === "ADMIN" || user?.user_role === "RECEPTION") {
//               setDate(arg.dateStr); 
//               setView("create_issue"); 
//           }
//         }} 
//         onEventClick={(info) => { 
//           // 🛡️ CLEAN THE ID IMMEDIATELY: "issue-123" becomes "123"
//           const rawId = info.event.id;
//           const cleanId = rawId.replace('issue-', '');
//           setSelectedEventId(cleanId);

//           // Check if task is already closed (optional: prevent editing closed tasks)
//           const isClosed = info.event.backgroundColor === '#4caf50';
//           if (isClosed && user?.user_role !== "ADMIN") {
//               alert("This task is already completed.");
//               return;
//           }

//           // 🛡️ LOGIC: If Tech/Maid, show Resolve Modal. Else show full Edit Modal.
//           if (user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") {
//             setResolveData({
//               endTime: new Date().toISOString().slice(0, 16), // Default to current time
//               comment: ""
//             });
//             setOpenResolveModal(true);
//           } else {
//             setOpenEditModal(true); 
//           }
//         }} 
//       />

//       {/* 1. ORIGINAL MODAL (For Admins/Reception) */}
//       <AppointmentEditModal 
//         open={openEditModal} 
//         id={selectedEventId} 
//         handleClose={() => setOpenEditModal(false)} 
//         refresh={getEventList} 
//       />

//       {/* 🛠️ 2. RESOLUTION MODAL (For Technicians/Maids) */}
//       <Dialog 
//         open={openResolveModal} 
//         onClose={() => setOpenResolveModal(false)}
//         fullWidth
//         maxWidth="xs"
//         PaperProps={{ sx: { borderRadius: 2 } }}
//       >
//         <DialogTitle sx={{ fontWeight: 'bold', bgcolor: '#f5f5f5' }}>
//           Complete Task
//         </DialogTitle>
//         <DialogContent dividers>
//           <Stack spacing={3} sx={{ mt: 1 }}>
//             <Typography variant="body2" color="textSecondary">
//               Please enter the completion time and any relevant comments.
//             </Typography>
//             <TextField
//               label="Actual End Date & Time"
//               type="datetime-local"
//               fullWidth
//               value={resolveData.endTime}
//               onChange={(e) => setResolveData({ ...resolveData, endTime: e.target.value })}
//               InputLabelProps={{ shrink: true }}
//             />
//             <TextField
//               label="Staff Comments / Actions Taken"
//               placeholder="e.g. Changed lightbulb, cleaned bathroom..."
//               multiline
//               rows={4}
//               fullWidth
//               value={resolveData.comment}
//               onChange={(e) => setResolveData({ ...resolveData, comment: e.target.value })}
//             />
//           </Stack>
//         </DialogContent>
//         <DialogActions sx={{ p: 2, bgcolor: '#f5f5f5' }}>
//           <Button onClick={() => setOpenResolveModal(false)} color="inherit">
//             Cancel
//           </Button>
//           <Button 
//             variant="contained" 
//             color="success" 
//             onClick={handleResolveSubmit}
//           >
//             Submit & Close Task
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }

// export default FullCalendarApp;

//////////////////////

// import { useState, useEffect, useCallback } from "react";
// import Button from "@mui/material/Button";
// import DaysCalendar from "./DaysCalendar";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import AppointmentEditModal from "./AppointmentEditModal";
// import { 
//   Box, Dialog, DialogTitle, DialogContent, 
//   DialogActions, TextField, Stack, Typography 
// } from "@mui/material";

// function FullCalendarApp() {
//   const [events, setEvents] = useState([]);
//   const [selectedEventId, setSelectedEventId] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);
  
//   // 🛠️ NEW: State to toggle visibility of closed tasks
//   const [hideClosed, setHideClosed] = useState(false);

//   const [openResolveModal, setOpenResolveModal] = useState(false);
//   const [resolveData, setResolveData] = useState({ endTime: '', comment: '' });

//   const { user, setView, setDate } = useStateContext();

//   const getEventList = useCallback(async () => {
//     try {
//       const [apptRes, issueRes] = await Promise.all([
//         axiosClient.get("/api/appointments/"),
//         axiosClient.get("/api/issues/")
//       ]);

//       const issueEvents = (issueRes.data || []).map((issue) => {
//         return {
//           id: `issue-${issue.id}`,
//           title: `${issue.title} [Room: ${issue.room_number}]`,
//           start: issue.appt_start, 
//           end: issue.appt_end ? issue.appt_end : issue.appt_start,
//           backgroundColor: issue.status === 'closed' ? '#4caf50' : '#e91e63',
//           allDay: false, 
//           display: 'block', 
//           extendedProps: { status: issue.status } // 🛠️ Store status for filtering
//         };
//       });

//       setEvents([...issueEvents]);
//     } catch (err) { console.error(err); }
//   }, []);

//   useEffect(() => { if (user) getEventList(); }, [user, getEventList]);

//   // 🛠️ NEW: Filtered events logic
//   const displayedEvents = hideClosed 
//     ? events.filter(e => e.extendedProps.status !== 'closed') 
//     : events;

//   const handleResolveSubmit = async () => {
//     try {
//       const cleanId = selectedEventId.toString().replace('issue-', '');
//       await axiosClient.post(`/api/close-issue/${cleanId}/`, {
//         end_time: resolveData.endTime,
//         comment: resolveData.comment
//       });
//       setOpenResolveModal(false);
//       getEventList();
//     } catch (err) {
//       alert("Error: " + (err.response?.data?.error || "Failed to close task"));
//     }
//   };

//   return (
//     <div>
//       <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//         <Typography variant="h5" fontWeight="bold">
//           {user?.user_role === "ADMIN" ? "Hotel Calendar" : "My Tasks Calendar"}
//         </Typography>

//         <Box sx={{ display: 'flex', gap: 1 }}>
//           {/* 🛠️ NEW BUTTON: Only visible for Maid/Technician */}
//           {(user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") && (
//             <Button 
//               variant="outlined" 
//               color="secondary"
//               onClick={() => setHideClosed(!hideClosed)}
//             >
//               {hideClosed ? "Show Closed Tasks" : "Remove Closed Tasks"}
//             </Button>
//           )}

//           {(user?.user_role === "ADMIN" || user?.user_role === "RECEPTION") && (
//             <Button variant="contained" onClick={() => setView("create_issue")}>
//               Log New Issue
//             </Button>
//           )}
//         </Box>
//       </Box>

//       <DaysCalendar 
//         events={displayedEvents} // 🛠️ Pass filtered events here
//         onEventClick={(info) => { 
//           const cleanId = info.event.id.replace('issue-', '');
//           setSelectedEventId(cleanId);

//           if (user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") {
//             setResolveData({ endTime: new Date().toISOString().slice(0, 16), comment: "" });
//             setOpenResolveModal(true);
//           } else {
//             setOpenEditModal(true); 
//           }
//         }} 
//       />

//       {/* AppointmentEditModal and Resolution Dialog remain the same... */}
//       <AppointmentEditModal 
//         open={openEditModal} 
//         id={selectedEventId} 
//         handleClose={() => setOpenEditModal(false)} 
//         refresh={getEventList} 
//       />

//       <Dialog open={openResolveModal} onClose={() => setOpenResolveModal(false)}>
//         <DialogTitle>Complete Task</DialogTitle>
//         <DialogContent dividers>
//           <Stack spacing={3} sx={{ mt: 1 }}>
//             <TextField
//               label="End Date & Time"
//               type="datetime-local"
//               fullWidth
//               value={resolveData.endTime}
//               onChange={(e) => setResolveData({ ...resolveData, endTime: e.target.value })}
//               InputLabelProps={{ shrink: true }}
//             />
//             <TextField
//               label="Staff Comments"
//               multiline
//               rows={4}
//               fullWidth
//               value={resolveData.comment}
//               onChange={(e) => setResolveData({ ...resolveData, comment: e.target.value })}
//             />
//           </Stack>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenResolveModal(false)}>Cancel</Button>
//           <Button variant="contained" color="success" onClick={handleResolveSubmit}>
//             Submit & Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }

// export default FullCalendarApp;


////////////////////


// import { useState, useEffect, useCallback } from "react";
// import Button from "@mui/material/Button";
// import DaysCalendar from "./DaysCalendar";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import AppointmentEditModal from "./AppointmentEditModal";
// import { 
//   Box, Dialog, DialogTitle, DialogContent, 
//   DialogActions, TextField, Stack, Typography 
// } from "@mui/material";

// function FullCalendarApp() {
//   const [events, setEvents] = useState([]);
//   const [selectedEventId, setSelectedEventId] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);
  
//   // State to toggle visibility of closed tasks
//   const [hideClosed, setHideClosed] = useState(false);

//   const [openResolveModal, setOpenResolveModal] = useState(false);
//   const [resolveData, setResolveData] = useState({ endTime: '', comment: '' });

//   const { user, setView, setDate } = useStateContext();

//   const getEventList = useCallback(async () => {
//     try {
//       const [apptRes, issueRes] = await Promise.all([
//         axiosClient.get("/api/appointments/"),
//         axiosClient.get("/api/issues/")
//       ]);

//       const issueEvents = (issueRes.data || []).map((issue) => {
//         return {
//           id: `issue-${issue.id}`,
//           title: `${issue.title} [Room: ${issue.room_number}]`,
//           start: issue.appt_start, 
//           end: issue.appt_end ? issue.appt_end : issue.appt_start,
//           backgroundColor: issue.status === 'closed' ? '#4caf50' : '#e91e63',
//           allDay: false, 
//           display: 'block', 
//           extendedProps: { status: issue.status } 
//         };
//       });

//       setEvents([...issueEvents]);
//     } catch (err) { console.error(err); }
//   }, []);

//   useEffect(() => { if (user) getEventList(); }, [user, getEventList]);

//   // Filtered events logic based on the toggle button
//   const displayedEvents = hideClosed 
//     ? events.filter(e => e.extendedProps.status !== 'closed') 
//     : events;

//   const handleResolveSubmit = async () => {
//     try {
//       const cleanId = selectedEventId.toString().replace('issue-', '');
//       await axiosClient.post(`/api/close-issue/${cleanId}/`, {
//         end_time: resolveData.endTime,
//         comment: resolveData.comment
//       });
//       setOpenResolveModal(false);
//       getEventList();
//     } catch (err) {
//       alert("Error: " + (err.response?.data?.error || "Failed to close task"));
//     }
//   };

//   return (
//     <div>
//       <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//         <Typography variant="h5" fontWeight="bold">
//           {user?.user_role === "ADMIN" ? "Hotel Calendar" : "My Tasks Calendar"}
//         </Typography>

//         <Box sx={{ display: 'flex', gap: 1 }}>
//           {/* 🛠️ REMOVE CLOSED TASKS: Now visible for ALL users */}
//           <Button 
//             variant="outlined" 
//             color="secondary"
//             onClick={() => setHideClosed(!hideClosed)}
//             sx={{ fontWeight: 'bold' }}
//           >
//             {hideClosed ? "Show Closed Tasks" : "Remove Closed Tasks"}
//           </Button>

//           {/* 🛠️ LOG NEW ISSUE: Button is now REMOVED for all roles in this view 
//               to match your request for Admin and Reception cleanup */}
//         </Box>
//       </Box>

//       <DaysCalendar 
//         events={displayedEvents} 
//         onEventClick={(info) => { 
//           const cleanId = info.event.id.replace('issue-', '');
//           setSelectedEventId(cleanId);

//           if (user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") {
//             setResolveData({ endTime: new Date().toISOString().slice(0, 16), comment: "" });
//             setOpenResolveModal(true);
//           } else {
//             setOpenEditModal(true); 
//           }
//         }} 
//       />

//       {/* Admin/Reception Edit Modal */}
//       <AppointmentEditModal 
//         open={openEditModal} 
//         id={selectedEventId} 
//         handleClose={() => setOpenEditModal(false)} 
//         refresh={getEventList} 
//       />

//       {/* Maid/Technician Completion Modal */}
//       <Dialog 
//         open={openResolveModal} 
//         onClose={() => setOpenResolveModal(false)}
//         fullWidth
//         maxWidth="xs"
//       >
//         <DialogTitle sx={{ fontWeight: 'bold' }}>Complete Task</DialogTitle>
//         <DialogContent dividers>
//           <Stack spacing={3} sx={{ mt: 1 }}>
//             <TextField
//               label="End Date & Time"
//               type="datetime-local"
//               fullWidth
//               value={resolveData.endTime}
//               onChange={(e) => setResolveData({ ...resolveData, endTime: e.target.value })}
//               InputLabelProps={{ shrink: true }}
//             />
//             <TextField
//               label="Staff Comments / Actions Taken"
//               multiline
//               rows={4}
//               fullWidth
//               value={resolveData.comment}
//               onChange={(e) => setResolveData({ ...resolveData, comment: e.target.value })}
//             />
//           </Stack>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button onClick={() => setOpenResolveModal(false)}>Cancel</Button>
//           <Button variant="contained" color="success" onClick={handleResolveSubmit}>
//             Submit & Close Task
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }

// export default FullCalendarApp;


////////////////////////////////////////////////////////////////////////////////////



// import { useState, useEffect, useCallback } from "react";
// import Button from "@mui/material/Button";
// import DaysCalendar from "./DaysCalendar";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import AppointmentEditModal from "./AppointmentEditModal";
// import { 
//   Box, Dialog, DialogTitle, DialogContent, 
//   DialogActions, TextField, Stack, Typography 
// } from "@mui/material";

// function FullCalendarApp() {
//   const [events, setEvents] = useState([]);
//   const [selectedEventId, setSelectedEventId] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);
  
//   // State to toggle visibility of closed tasks
//   const [hideClosed, setHideClosed] = useState(false);

//   const [openResolveModal, setOpenResolveModal] = useState(false);
//   const [resolveData, setResolveData] = useState({ endTime: '', comment: '' });

//   const { user, setView, setDate } = useStateContext();

//   const getEventList = useCallback(async () => {
//     try {
//       const [apptRes, issueRes] = await Promise.all([
//         axiosClient.get("/api/appointments/"),
//         axiosClient.get("/api/issues/")
//       ]);

//       const issueEvents = (issueRes.data || []).map((issue) => {
//         return {
//           id: `issue-${issue.id}`,
//           title: `${issue.title} [Room: ${issue.room_number}]`,
//           start: issue.appt_start, 
//           end: issue.appt_end ? issue.appt_end : issue.appt_start,
//           backgroundColor: issue.status === 'closed' ? '#4caf50' : '#e91e63',
//           allDay: false, 
//           display: 'block', 
//           extendedProps: { status: issue.status } 
//         };
//       });

//       setEvents([...issueEvents]);
//     } catch (err) { console.error(err); }
//   }, []);

//   useEffect(() => { if (user) getEventList(); }, [user, getEventList]);

//   // Filtered events logic based on the toggle button
//   const displayedEvents = hideClosed 
//     ? events.filter(e => e.extendedProps.status !== 'closed') 
//     : events;

//   const handleResolveSubmit = async () => {
//     try {
//       const cleanId = selectedEventId.toString().replace('issue-', '');
//       await axiosClient.post(`/api/close-issue/${cleanId}/`, {
//         end_time: resolveData.endTime,
//         comment: resolveData.comment
//       });
//       setOpenResolveModal(false);
//       getEventList();
//     } catch (err) {
//       alert("Error: " + (err.response?.data?.error || "Failed to close task"));
//     }
//   };

//   return (
//     <div>
//       <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//         <Typography variant="h5" fontWeight="bold">
//           {user?.user_role === "ADMIN" || user?.user_role === "RECEPTION" 
//             ? "Hotel Management Calendar" 
//             : "My Tasks Calendar"}
//         </Typography>

//         <Box sx={{ display: 'flex', gap: 1 }}>
//           {/* 🛠️ REMOVE CLOSED TASKS: Visible for ALL users */}
//           <Button 
//             variant="outlined" 
//             color="secondary"
//             onClick={() => setHideClosed(!hideClosed)}
//             sx={{ fontWeight: 'bold' }}
//           >
//             {hideClosed ? "Show Closed Tasks" : "Remove Closed Tasks"}
//           </Button>

//           {/* 🛠️ LOG NEW ISSUE: Now specifically enabled for ADMIN and RECEPTION */}
//           {(user?.user_role === "ADMIN" || user?.user_role === "RECEPTION") && (
//             <Button 
//               variant="contained" 
//               color="primary" 
//               onClick={() => setView("create_issue")}
//               sx={{ fontWeight: 'bold' }}
//             >
//               Log New Issue
//             </Button>
//           )}
//         </Box>
//       </Box>

//       <DaysCalendar 
//         events={displayedEvents} 
//         onEventClick={(info) => { 
//           const cleanId = info.event.id.replace('issue-', '');
//           setSelectedEventId(cleanId);

//           if (user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") {
//             setResolveData({ endTime: new Date().toISOString().slice(0, 16), comment: "" });
//             setOpenResolveModal(true);
//           } else {
//             setOpenEditModal(true); 
//           }
//         }} 
//       />

//       {/* Admin/Reception Edit Modal */}
//       <AppointmentEditModal 
//         open={openEditModal} 
//         id={selectedEventId} 
//         handleClose={() => setOpenEditModal(false)} 
//         refresh={getEventList} 
//       />

//       {/* Maid/Technician Completion Modal */}
//       <Dialog 
//         open={openResolveModal} 
//         onClose={() => setOpenResolveModal(false)}
//         fullWidth
//         maxWidth="xs"
//       >
//         <DialogTitle sx={{ fontWeight: 'bold' }}>Complete Task</DialogTitle>
//         <DialogContent dividers>
//           <Stack spacing={3} sx={{ mt: 1 }}>
//             <TextField
//               label="End Date & Time"
//               type="datetime-local"
//               fullWidth
//               value={resolveData.endTime}
//               onChange={(e) => setResolveData({ ...resolveData, endTime: e.target.value })}
//               InputLabelProps={{ shrink: true }}
//             />
//             <TextField
//               label="Staff Comments / Actions Taken"
//               multiline
//               rows={4}
//               fullWidth
//               value={resolveData.comment}
//               onChange={(e) => setResolveData({ ...resolveData, comment: e.target.value })}
//             />
//           </Stack>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button onClick={() => setOpenResolveModal(false)}>Cancel</Button>
//           <Button variant="contained" color="success" onClick={handleResolveSubmit}>
//             Submit & Close Task
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }

// export default FullCalendarApp;


////////////////////////////////////////////////////////////////////////////////////

// import { useState, useEffect, useCallback } from "react";
// import Button from "@mui/material/Button";
// import DaysCalendar from "./DaysCalendar";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import AppointmentEditModal from "./AppointmentEditModal";
// import { 
//   Box, Dialog, DialogTitle, DialogContent, 
//   DialogActions, TextField, Stack, Typography 
// } from "@mui/material";

// function FullCalendarApp() {
//   const [events, setEvents] = useState([]);
//   const [selectedEventId, setSelectedEventId] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);
  
//   // State to toggle visibility of closed tasks
//   const [hideClosed, setHideClosed] = useState(false);

//   const [openResolveModal, setOpenResolveModal] = useState(false);
//   const [resolveData, setResolveData] = useState({ endTime: '', comment: '' });

//   const { user, setView } = useStateContext();

//   const getEventList = useCallback(async () => {
//     try {
//       // 🛠️ We use issue-list-data because it now contains the 'tech_color' 
//       const [apptRes, issueRes] = await Promise.all([
//         axiosClient.get("/api/appointments/"),
//         axiosClient.get("/api/issue-list-data/") 
//       ]);

//       const issueEvents = (issueRes.data || []).map((issue) => {
//         // 🛠️ Logic: If closed -> Green. If open -> Staff's specific color.
//         const eventColor = issue.status === 'closed' ? '#4caf50' : (issue.tech_color || '#e91e63');

//         return {
//           id: `issue-${issue.id}`,
//           title: `${issue.title} [Room: ${issue.room_number}]`,
//           start: issue.appt_start, 
//           end: issue.scheduled_end ? issue.scheduled_end : issue.appt_start,
//           backgroundColor: eventColor,
//           borderColor: eventColor,
//           allDay: false, 
//           display: 'block', 
//           extendedProps: { 
//             status: issue.status,
//             staff: issue.staff_name 
//           } 
//         };
//       });

//       setEvents([...issueEvents]);
//     } catch (err) { console.error(err); }
//   }, []);

//   useEffect(() => { if (user) getEventList(); }, [user, getEventList]);

//   // Filtered events logic based on the toggle button
//   const displayedEvents = hideClosed 
//     ? events.filter(e => e.extendedProps.status !== 'closed') 
//     : events;

//   const handleResolveSubmit = async () => {
//     try {
//       const cleanId = selectedEventId.toString().replace('issue-', '');
//       await axiosClient.post(`/api/close-issue/${cleanId}/`, {
//         end_time: resolveData.endTime,
//         comment: resolveData.comment
//       });
//       setOpenResolveModal(false);
//       getEventList();
//     } catch (err) {
//       alert("Error: " + (err.response?.data?.error || "Failed to close task"));
//     }
//   };

//   return (
//     <div>
//       <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//         <Typography variant="h5" fontWeight="bold">
//           {user?.user_role === "ADMIN" || user?.user_role === "RECEPTION" 
//             ? "Hotel Management Calendar" 
//             : "My Tasks Calendar"}
//         </Typography>

//         <Box sx={{ display: 'flex', gap: 1 }}>
//           <Button 
//             variant="outlined" 
//             color="secondary"
//             onClick={() => setHideClosed(!hideClosed)}
//             sx={{ fontWeight: 'bold' }}
//           >
//             {hideClosed ? "Show Closed Tasks" : "Remove Closed Tasks"}
//           </Button>

//           {(user?.user_role === "ADMIN" || user?.user_role === "RECEPTION") && (
//             <Button 
//               variant="contained" 
//               color="primary" 
//               onClick={() => setView("create_issue")}
//               sx={{ fontWeight: 'bold' }}
//             >
//               Log New Issue
//             </Button>
//           )}
//         </Box>
//       </Box>

//       <DaysCalendar 
//         events={displayedEvents} 
//         onEventClick={(info) => { 
//           const cleanId = info.event.id.replace('issue-', '');
//           setSelectedEventId(cleanId);

//           if (user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") {
//             setResolveData({ endTime: new Date().toISOString().slice(0, 16), comment: "" });
//             setOpenResolveModal(true);
//           } else {
//             setOpenEditModal(true); 
//           }
//         }} 
//       />

//       <AppointmentEditModal 
//         open={openEditModal} 
//         id={selectedEventId} 
//         handleClose={() => setOpenEditModal(false)} 
//         refresh={getEventList} 
//       />

//       <Dialog 
//         open={openResolveModal} 
//         onClose={() => setOpenResolveModal(false)}
//         fullWidth
//         maxWidth="xs"
//       >
//         <DialogTitle sx={{ fontWeight: 'bold' }}>Complete Task</DialogTitle>
//         <DialogContent dividers>
//           <Stack spacing={3} sx={{ mt: 1 }}>
//             <TextField
//               label="End Date & Time"
//               type="datetime-local"
//               fullWidth
//               value={resolveData.endTime}
//               onChange={(e) => setResolveData({ ...resolveData, endTime: e.target.value })}
//               InputLabelProps={{ shrink: true }}
//             />
//             <TextField
//               label="Staff Comments / Actions Taken"
//               multiline
//               rows={4}
//               fullWidth
//               value={resolveData.comment}
//               onChange={(e) => setResolveData({ ...resolveData, comment: e.target.value })}
//             />
//           </Stack>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button onClick={() => setOpenResolveModal(false)}>Cancel</Button>
//           <Button variant="contained" color="success" onClick={handleResolveSubmit}>
//             Submit & Close Task
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }

// export default FullCalendarApp;

////////////////////////////////////////////////////////////////////////////////////


// import { useState, useEffect, useCallback } from "react";
// import Button from "@mui/material/Button";
// import DaysCalendar from "./DaysCalendar";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import AppointmentEditModal from "./AppointmentEditModal";
// import { 
//   Box, Dialog, DialogTitle, DialogContent, 
//   DialogActions, TextField, Stack, Typography,
//   useMediaQuery, useTheme 
// } from "@mui/material";

// function FullCalendarApp() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Detects mobile screens

//   const [events, setEvents] = useState([]);
//   const [selectedEventId, setSelectedEventId] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [hideClosed, setHideClosed] = useState(false);
//   const [openResolveModal, setOpenResolveModal] = useState(false);
//   const [resolveData, setResolveData] = useState({ endTime: '', comment: '' });

//   const { user, setView } = useStateContext();

//   const getEventList = useCallback(async () => {
//     try {
//       const [apptRes, issueRes] = await Promise.all([
//         axiosClient.get("/api/appointments/"),
//         axiosClient.get("/api/issue-list-data/") 
//       ]);

//       const issueEvents = (issueRes.data || []).map((issue) => {
//         const eventColor = issue.status === 'closed' ? '#4caf50' : (issue.tech_color || '#e91e63');
//         return {
//           id: `issue-${issue.id}`,
//           title: `${issue.title} [Room: ${issue.room_number}]`,
//           start: issue.appt_start, 
//           end: issue.scheduled_end ? issue.scheduled_end : issue.appt_start,
//           backgroundColor: eventColor,
//           borderColor: eventColor,
//           allDay: false, 
//           display: 'block', 
//           extendedProps: { 
//             status: issue.status,
//             staff: issue.staff_name 
//           } 
//         };
//       });

//       setEvents([...issueEvents]);
//     } catch (err) { console.error(err); }
//   }, []);

//   useEffect(() => { if (user) getEventList(); }, [user, getEventList]);

//   const displayedEvents = hideClosed 
//     ? events.filter(e => e.extendedProps.status !== 'closed') 
//     : events;

//   const handleResolveSubmit = async () => {
//     try {
//       const cleanId = selectedEventId.toString().replace('issue-', '');
//       await axiosClient.post(`/api/close-issue/${cleanId}/`, {
//         end_time: resolveData.endTime,
//         comment: resolveData.comment
//       });
//       setOpenResolveModal(false);
//       getEventList();
//     } catch (err) {
//       alert("Error: " + (err.response?.data?.error || "Failed to close task"));
//     }
//   };

//   return (
//     <div>
//       {/* 🛠️ RESPONSIVE HEADER BOX */}
//       <Box sx={{ 
//         mb: 2, 
//         display: 'flex', 
//         flexDirection: isMobile ? 'column' : 'row', 
//         justifyContent: 'space-between', 
//         alignItems: isMobile ? 'flex-start' : 'center',
//         gap: 2 
//       }}>
//         <Typography variant={isMobile ? "h6" : "h5"} fontWeight="bold">
//           {user?.user_role === "ADMIN" || user?.user_role === "RECEPTION" 
//             ? (isMobile ? "Management" : "Hotel Management Calendar") 
//             : (isMobile ? "My Tasks" : "My Tasks Calendar")}
//         </Typography>

//         <Box sx={{ 
//           display: 'flex', 
//           gap: 1, 
//           width: isMobile ? '100%' : 'auto',
//           justifyContent: isMobile ? 'space-between' : 'flex-end'
//         }}>
//           {/* 🛠️ RESPONSIVE BUTTON: Shorter text on mobile */}
//           <Button 
//             variant="outlined" 
//             color="secondary"
//             onClick={() => setHideClosed(!hideClosed)}
//             sx={{ 
//               fontWeight: 'bold', 
//               flex: isMobile ? 1 : 'none',
//               fontSize: isMobile ? '0.75rem' : '0.875rem' 
//             }}
//           >
//             {hideClosed 
//               ? (isMobile ? "Show Closed" : "Show Closed Tasks") 
//               : (isMobile ? "Hide Closed" : "Remove Closed Tasks")
//             }
//           </Button>

//           {(user?.user_role === "ADMIN" || user?.user_role === "RECEPTION") && (
//             <Button 
//               variant="contained" 
//               color="primary" 
//               onClick={() => setView("create_issue")}
//               sx={{ 
//                 fontWeight: 'bold', 
//                 flex: isMobile ? 1 : 'none',
//                 fontSize: isMobile ? '0.75rem' : '0.875rem' 
//               }}
//             >
//               {isMobile ? "New Issue" : "Log New Issue"}
//             </Button>
//           )}
//         </Box>
//       </Box>

//       <DaysCalendar 
//         events={displayedEvents} 
//         onEventClick={(info) => { 
//           const cleanId = info.event.id.replace('issue-', '');
//           setSelectedEventId(cleanId);
//           if (user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") {
//             setResolveData({ endTime: new Date().toISOString().slice(0, 16), comment: "" });
//             setOpenResolveModal(true);
//           } else {
//             setOpenEditModal(true); 
//           }
//         }} 
//       />

//       <AppointmentEditModal 
//         open={openEditModal} 
//         id={selectedEventId} 
//         handleClose={() => setOpenEditModal(false)} 
//         refresh={getEventList} 
//       />

//       <Dialog open={openResolveModal} onClose={() => setOpenResolveModal(false)} fullWidth maxWidth="xs">
//         <DialogTitle sx={{ fontWeight: 'bold' }}>Complete Task</DialogTitle>
//         <DialogContent dividers>
//           <Stack spacing={3} sx={{ mt: 1 }}>
//             <TextField
//               label="End Date & Time"
//               type="datetime-local"
//               fullWidth
//               value={resolveData.endTime}
//               onChange={(e) => setResolveData({ ...resolveData, endTime: e.target.value })}
//               InputLabelProps={{ shrink: true }}
//             />
//             <TextField
//               label="Staff Comments / Actions Taken"
//               multiline rows={4} fullWidth
//               value={resolveData.comment}
//               onChange={(e) => setResolveData({ ...resolveData, comment: e.target.value })}
//             />
//           </Stack>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button onClick={() => setOpenResolveModal(false)}>Cancel</Button>
//           <Button variant="contained" color="success" onClick={handleResolveSubmit}>
//             Submit & Close Task
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }

// export default FullCalendarApp;


// ////////////////////////////////////////////////////////////////////////////////////

// import { useState, useEffect, useCallback } from "react";
// import Button from "@mui/material/Button";
// import DaysCalendar from "./DaysCalendar";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import AppointmentEditModal from "./AppointmentEditModal";
// import { 
//   Box, Dialog, DialogTitle, DialogContent, 
//   DialogActions, TextField, Stack, Typography,
//   useMediaQuery, useTheme 
// } from "@mui/material";

// function FullCalendarApp() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // 📱 Check if mobile

//   const [events, setEvents] = useState([]);
//   const [selectedEventId, setSelectedEventId] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [hideClosed, setHideClosed] = useState(false);
//   const [openResolveModal, setOpenResolveModal] = useState(false);
//   const [resolveData, setResolveData] = useState({ endTime: '', comment: '' });

//   const { user, setView } = useStateContext();

//   const getEventList = useCallback(async () => {
//     try {
//       const [apptRes, issueRes] = await Promise.all([
//         axiosClient.get("/api/appointments/"),
//         axiosClient.get("/api/issue-list-data/") 
//       ]);

//       const issueEvents = (issueRes.data || []).map((issue) => {
//         const eventColor = issue.status === 'closed' ? '#4caf50' : (issue.tech_color || '#e91e63');
//         return {
//           id: `issue-${issue.id}`,
//           title: `${issue.title} [Room: ${issue.room_number}]`,
//           start: issue.appt_start, 
//           end: issue.scheduled_end ? issue.scheduled_end : issue.appt_start,
//           backgroundColor: eventColor,
//           borderColor: eventColor,
//           allDay: false, 
//           display: 'block', 
//           extendedProps: { 
//             status: issue.status,
//             staff: issue.staff_name 
//           } 
//         };
//       });
//       setEvents([...issueEvents]);
//     } catch (err) { console.error(err); }
//   }, []);

//   useEffect(() => { if (user) getEventList(); }, [user, getEventList]);

//   const displayedEvents = hideClosed 
//     ? events.filter(e => e.extendedProps.status !== 'closed') 
//     : events;

//   const handleResolveSubmit = async () => {
//     try {
//       const cleanId = selectedEventId.toString().replace('issue-', '');
//       await axiosClient.post(`/api/close-issue/${cleanId}/`, {
//         end_time: resolveData.endTime,
//         comment: resolveData.comment
//       });
//       setOpenResolveModal(false);
//       getEventList();
//     } catch (err) {
//       alert("Error: " + (err.response?.data?.error || "Failed to close task"));
//     }
//   };

//   return (
//     <div>
//       {/* 🛠️ RESPONSIVE HEADER FIX */}
//       <Box sx={{ 
//         mb: 2, 
//         display: 'flex', 
//         flexDirection: isMobile ? 'column' : 'row', // Stack vertically on mobile
//         justifyContent: 'space-between', 
//         alignItems: isMobile ? 'stretch' : 'center',
//         gap: 1.5 
//       }}>
//         <Typography variant={isMobile ? "h6" : "h5"} fontWeight="bold">
//           {user?.user_role === "ADMIN" || user?.user_role === "RECEPTION" 
//             ? "Hotel Management" 
//             : "My Tasks"}
//         </Typography>

//         <Box sx={{ 
//           display: 'flex', 
//           gap: 1, 
//           width: isMobile ? '100%' : 'auto', // Take full width on mobile
//         }}>
//           <Button 
//             variant="outlined" 
//             color="secondary"
//             onClick={() => setHideClosed(!hideClosed)}
//             sx={{ 
//               fontWeight: 'bold', 
//               flex: 1, // Make buttons equal width on mobile
//               fontSize: isMobile ? '0.7rem' : '0.85rem' // Smaller text for mobile
//             }}
//           >
//             {/* 🛠️ Short labels for mobile */}
//             {hideClosed 
//               ? (isMobile ? "Show All" : "Show Closed Tasks") 
//               : (isMobile ? "Hide Closed" : "Remove Closed Tasks")
//             }
//           </Button>

//           {(user?.user_role === "ADMIN" || user?.user_role === "RECEPTION") && (
//             <Button 
//               variant="contained" 
//               color="primary" 
//               onClick={() => setView("create_issue")}
//               sx={{ 
//                 fontWeight: 'bold', 
//                 flex: 1,
//                 fontSize: isMobile ? '0.7rem' : '0.85rem'
//               }}
//             >
//               {isMobile ? "New Issue" : "Log New Issue"}
//             </Button>
//           )}
//         </Box>
//       </Box>

//       <DaysCalendar 
//         events={displayedEvents} 
//         onEventClick={(info) => { 
//           const cleanId = info.event.id.replace('issue-', '');
//           setSelectedEventId(cleanId);
//           if (user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") {
//             setResolveData({ endTime: new Date().toISOString().slice(0, 16), comment: "" });
//             setOpenResolveModal(true);
//           } else {
//             setOpenEditModal(true); 
//           }
//         }} 
//       />

//       <AppointmentEditModal 
//         open={openEditModal} 
//         id={selectedEventId} 
//         handleClose={() => setOpenEditModal(false)} 
//         refresh={getEventList} 
//       />

//       {/* Resolution Dialog remains the same... */}
//       <Dialog open={openResolveModal} onClose={() => setOpenResolveModal(false)} fullWidth maxWidth="xs">
//         <DialogTitle sx={{ fontWeight: 'bold' }}>Complete Task</DialogTitle>
//         <DialogContent dividers>
//           <Stack spacing={3} sx={{ mt: 1 }}>
//             <TextField
//               label="End Date & Time"
//               type="datetime-local"
//               fullWidth
//               value={resolveData.endTime}
//               onChange={(e) => setResolveData({ ...resolveData, endTime: e.target.value })}
//               InputLabelProps={{ shrink: true }}
//             />
//             <TextField
//               label="Staff Comments"
//               multiline rows={4} fullWidth
//               value={resolveData.comment}
//               onChange={(e) => setResolveData({ ...resolveData, comment: e.target.value })}
//             />
//           </Stack>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button onClick={() => setOpenResolveModal(false)}>Cancel</Button>
//           <Button variant="contained" color="success" onClick={handleResolveSubmit}>
//             Submit & Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }

// export default FullCalendarApp;

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// import { useState, useEffect, useCallback } from "react";
// import Button from "@mui/material/Button";
// import DaysCalendar from "./DaysCalendar";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import AppointmentEditModal from "./AppointmentEditModal";
// import { 
//   Box, Dialog, DialogTitle, DialogContent, 
//   DialogActions, TextField, Stack, Typography,
//   useMediaQuery, useTheme 
// } from "@mui/material";

// function FullCalendarApp() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm")); 

//   const [events, setEvents] = useState([]);
//   const [selectedEventId, setSelectedEventId] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [hideClosed, setHideClosed] = useState(false);
//   const [openResolveModal, setOpenResolveModal] = useState(false);
//   const [resolveData, setResolveData] = useState({ endTime: '', comment: '' });

//   const { user, setView } = useStateContext();

//   const getEventList = useCallback(async () => {
//     try {
//       const [apptRes, issueRes] = await Promise.all([
//         axiosClient.get("/api/appointments/"),
//         axiosClient.get("/api/issue-list-data/") 
//       ]);

//       const issueEvents = (issueRes.data || []).map((issue) => {
//         // 🎨 GREEN LOGIC: If status is 'closed', use the system green #4caf50.
//         // Otherwise, use the staff member's custom color.
//         const eventColor = issue.status === 'closed' 
//           ? '#4caf50' 
//           : (issue.tech_color || '#e91e63');

//         return {
//           id: `issue-${issue.id}`,
//           title: `${issue.title} [Room: ${issue.room_number}]`,
//           start: issue.appt_start, 
//           end: issue.scheduled_end ? issue.scheduled_end : issue.appt_start,
//           backgroundColor: eventColor,
//           borderColor: eventColor,
//           allDay: false, 
//           display: 'block', 
//           extendedProps: { 
//             status: issue.status,
//             staff: issue.staff_name 
//           } 
//         };
//       });
//       setEvents([...issueEvents]);
//     } catch (err) { console.error("Fetch Error:", err); }
//   }, []);

//   useEffect(() => { if (user) getEventList(); }, [user, getEventList]);

//   const displayedEvents = hideClosed 
//     ? events.filter(e => e.extendedProps.status !== 'closed') 
//     : events;

//   const handleResolveSubmit = async () => {
//     try {
//       const cleanId = selectedEventId.toString().replace('issue-', '');
//       await axiosClient.post(`/api/close-issue/${cleanId}/`, {
//         end_time: resolveData.endTime,
//         comment: resolveData.comment
//       });
//       setOpenResolveModal(false);
//       getEventList();
//     } catch (err) {
//       alert("Error: " + (err.response?.data?.error || "Failed to close task"));
//     }
//   };

//   return (
//     <div>
//       {/* 🛠️ RESPONSIVE HEADER: Fixed for the mobile squashing issue */}
//       <Box sx={{ 
//         mb: 2, 
//         display: 'flex', 
//         flexDirection: isMobile ? 'column' : 'row', 
//         justifyContent: 'space-between', 
//         alignItems: isMobile ? 'stretch' : 'center',
//         gap: 1.5 
//       }}>
//         <Typography variant={isMobile ? "h6" : "h5"} fontWeight="bold">
//           {user?.user_role === "ADMIN" || user?.user_role === "RECEPTION" 
//             ? "Hotel Management" 
//             : "My Tasks"}
//         </Typography>

//         <Box sx={{ 
//           display: 'flex', 
//           gap: 1, 
//           width: isMobile ? '100%' : 'auto', 
//         }}>
//           <Button 
//             variant="outlined" 
//             color="secondary"
//             onClick={() => setHideClosed(!hideClosed)}
//             sx={{ 
//               fontWeight: 'bold', 
//               flex: 1, 
//               fontSize: isMobile ? '0.7rem' : '0.85rem',
//               whiteSpace: 'nowrap'
//             }}
//           >
//             {hideClosed 
//               ? (isMobile ? "Show All" : "Show Closed Tasks") 
//               : (isMobile ? "Hide Closed" : "Remove Closed Tasks")
//             }
//           </Button>

//           {(user?.user_role === "ADMIN" || user?.user_role === "RECEPTION") && (
//             <Button 
//               variant="contained" 
//               color="primary" 
//               onClick={() => setView("create_issue")}
//               sx={{ 
//                 fontWeight: 'bold', 
//                 flex: 1,
//                 fontSize: isMobile ? '0.7rem' : '0.85rem',
//                 whiteSpace: 'nowrap'
//               }}
//             >
//               {isMobile ? "New Issue" : "Log New Issue"}
//             </Button>
//           )}
//         </Box>
//       </Box>

//       <DaysCalendar 
//         events={displayedEvents} 
//         onEventClick={(info) => { 
//           const cleanId = info.event.id.replace('issue-', '');
//           setSelectedEventId(cleanId);
//           if (user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") {
//             setResolveData({ endTime: new Date().toISOString().slice(0, 16), comment: "" });
//             setOpenResolveModal(true);
//           } else {
//             setOpenEditModal(true); 
//           }
//         }} 
//       />

//       <AppointmentEditModal 
//         open={openEditModal} 
//         id={selectedEventId} 
//         handleClose={() => setOpenEditModal(false)} 
//         refresh={getEventList} 
//       />

//       <Dialog open={openResolveModal} onClose={() => setOpenResolveModal(false)} fullWidth maxWidth="xs">
//         <DialogTitle sx={{ fontWeight: 'bold' }}>Complete Task</DialogTitle>
//         <DialogContent dividers>
//           <Stack spacing={3} sx={{ mt: 1 }}>
//             <TextField
//               label="End Date & Time"
//               type="datetime-local"
//               fullWidth
//               value={resolveData.endTime}
//               onChange={(e) => setResolveData({ ...resolveData, endTime: e.target.value })}
//               InputLabelProps={{ shrink: true }}
//             />
//             <TextField
//               label="Staff Comments"
//               multiline rows={4} fullWidth
//               value={resolveData.comment}
//               onChange={(e) => setResolveData({ ...resolveData, comment: e.target.value })}
//             />
//           </Stack>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button onClick={() => setOpenResolveModal(false)}>Cancel</Button>
//           <Button variant="contained" color="success" onClick={handleResolveSubmit}>
//             Submit & Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }

// export default FullCalendarApp;



////////////////////////////////////////////////////////////////////////////////////


// import { useState, useEffect, useCallback } from "react";
// import Button from "@mui/material/Button";
// import DaysCalendar from "./DaysCalendar";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import AppointmentEditModal from "./AppointmentEditModal";
// import { 
//   Box, Dialog, DialogTitle, DialogContent, 
//   DialogActions, TextField, Stack, Typography,
//   useMediaQuery, useTheme 
// } from "@mui/material";

// const getLocalDateTimeString = () => {
//   const now = new Date();
//   const offset = now.getTimezoneOffset() * 60000;
//   return new Date(now - offset).toISOString().slice(0, 16);
// };

// function FullCalendarApp() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm")); 

//   const [events, setEvents] = useState([]);
//   const [selectedEventId, setSelectedEventId] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [hideClosed, setHideClosed] = useState(false);
//   const [openResolveModal, setOpenResolveModal] = useState(false);
//   const [resolveData, setResolveData] = useState({ endTime: '', comment: '' });

//   const { user, setView } = useStateContext();

//   const getEventList = useCallback(async () => {
//     try {
//       const [apptRes, issueRes] = await Promise.all([
//         // axiosClient.get("/api/appointments/"),
//         axiosClient.get("appointments/"),
//         // axiosClient.get("/api/issue-list-data/") 
//         axiosClient.get("issue-list-data/") 
//       ]);

//       const issueEvents = (issueRes.data || []).map((issue) => {
//         const eventColor = issue.status === 'closed' 
//           ? '#4caf50' 
//           : (issue.tech_color || '#e91e63');

//         return {
//           id: `issue-${issue.id}`,
//           title: `${issue.title} [Room: ${issue.room_number}]`,
//           start: issue.appt_start, 
//           end: issue.scheduled_end ? issue.scheduled_end : issue.appt_start,
//           backgroundColor: eventColor,
//           borderColor: eventColor,
//           allDay: false, 
//           display: 'block', 
//           extendedProps: { 
//             status: issue.status,
//             staff: issue.staff_name 
//           } 
//         };
//       });
//       setEvents([...issueEvents]);
//     } catch (err) { console.error("Fetch Error:", err); }
//   }, []);

//   useEffect(() => { if (user) getEventList(); }, [user, getEventList]);

//   const displayedEvents = hideClosed 
//     ? events.filter(e => e.extendedProps.status !== 'closed') 
//     : events;

//   const handleResolveSubmit = async () => {
//     try {
//       const cleanId = selectedEventId.toString().replace('issue-', '');
//       // await axiosClient.post(`/api/close-issue/${cleanId}/`, {
//       await axiosClient.post(`close-issue/${cleanId}/`, {
//         end_time: resolveData.endTime,
//         comment: resolveData.comment
//       });
//       setOpenResolveModal(false);
//       getEventList();
//     } catch (err) {
//       alert("Error: " + (err.response?.data?.error || "Failed to close task"));
//     }
//   };

//   return (
//     <div>
//       <Box sx={{ 
//         mb: 2, 
//         display: 'flex', 
//         flexDirection: isMobile ? 'column' : 'row', 
//         justifyContent: 'space-between', 
//         alignItems: isMobile ? 'stretch' : 'center',
//         gap: 1.5 
//       }}>
//         <Typography variant={isMobile ? "h6" : "h5"} fontWeight="bold">
//           {user?.user_role === "ADMIN" || user?.user_role === "RECEPTION" 
//             ? "Hotel Management" 
//             : "My Tasks"}
//         </Typography>

//         <Box sx={{ 
//           display: 'flex', 
//           gap: 1, 
//           width: isMobile ? '100%' : 'auto', 
//         }}>
//           <Button 
//             variant="outlined" 
//             color="secondary"
//             onClick={() => setHideClosed(!hideClosed)}
//             sx={{ 
//               fontWeight: 'bold', 
//               flex: 1, 
//               fontSize: isMobile ? '0.7rem' : '0.85rem',
//               whiteSpace: 'nowrap'
//             }}
//           >
//             {hideClosed 
//               ? (isMobile ? "Show All" : "Show Closed Tasks") 
//               : (isMobile ? "Hide Closed" : "Remove Closed Tasks")
//             }
//           </Button>

//           {(user?.user_role === "ADMIN" || user?.user_role === "RECEPTION") && (
//             <Button 
//               variant="contained" 
//               color="primary" 
//               onClick={() => setView("create_issue")}
//               sx={{ 
//                 fontWeight: 'bold', 
//                 flex: 1,
//                 fontSize: isMobile ? '0.7rem' : '0.85rem',
//                 whiteSpace: 'nowrap'
//               }}
//             >
//               {isMobile ? "New Issue" : "Log New Issue"}
//             </Button>
//           )}
//         </Box>
//       </Box>

//       <DaysCalendar 
//         events={displayedEvents} 
//         onEventClick={(info) => { 
//           const cleanId = info.event.id.replace('issue-', '');
//           setSelectedEventId(cleanId);
//           if (user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") {
//             setResolveData({ endTime: getLocalDateTimeString(), comment: "" });
//             setOpenResolveModal(true);
//           } else {
//             setOpenEditModal(true); 
//           }
//         }} 
//       />

//       <AppointmentEditModal 
//         open={openEditModal} 
//         id={selectedEventId} 
//         handleClose={() => setOpenEditModal(false)} 
//         refresh={getEventList} 
//       />

//       <Dialog open={openResolveModal} onClose={() => setOpenResolveModal(false)} fullWidth maxWidth="xs">
//         <DialogTitle sx={{ fontWeight: 'bold' }}>Complete Task</DialogTitle>
//         <DialogContent dividers>
//           <Stack spacing={3} sx={{ mt: 1 }}>
//             <TextField
//               label="End Date & Time"
//               type="datetime-local"
//               fullWidth
//               value={resolveData.endTime}
//               onChange={(e) => setResolveData({ ...resolveData, endTime: e.target.value })}
//               InputLabelProps={{ shrink: true }}
//             />
//             <TextField
//               label="Staff Comments"
//               multiline rows={4} fullWidth
//               value={resolveData.comment}
//               onChange={(e) => setResolveData({ ...resolveData, comment: e.target.value })}
//             />
//           </Stack>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button onClick={() => setOpenResolveModal(false)}>Cancel</Button>
//           <Button variant="contained" color="success" onClick={handleResolveSubmit}>
//             Submit & Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }

// export default FullCalendarApp;

import { useState, useEffect, useCallback } from "react";
import Button from "@mui/material/Button";
import DaysCalendar from "./DaysCalendar";
import axiosClient from "../axiosClient";
import { useStateContext } from "../context/ContextProvider";
import AppointmentEditModal from "./AppointmentEditModal";
import { 
  Box, Dialog, DialogTitle, DialogContent, 
  DialogActions, TextField, Stack, Typography,
  useMediaQuery, useTheme 
} from "@mui/material";

const getLocalDateTimeString = () => {
  const now = new Date();
  const offset = now.getTimezoneOffset() * 60000;
  return new Date(now - offset).toISOString().slice(0, 16);
};

function FullCalendarApp() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); 

  const [events, setEvents] = useState([]);
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [hideClosed, setHideClosed] = useState(false);
  const [openResolveModal, setOpenResolveModal] = useState(false);
  const [resolveData, setResolveData] = useState({ endTime: '', comment: '' });

  const { user, setView } = useStateContext();

  const getEventList = useCallback(async () => {
    try {
      const [apptRes, issueRes] = await Promise.all([
        axiosClient.get("appointments/"),
        axiosClient.get("issue-list-data/") 
      ]);

      const issueEvents = (issueRes.data || []).map((issue) => {
        const eventColor = issue.status === 'closed' 
          ? '#4caf50' 
          : (issue.tech_color || '#e91e63');

        return {
          id: `issue-${issue.id}`,
          title: `${issue.title} [Room: ${issue.room_number}]`,
          start: issue.appt_start, 
          end: issue.scheduled_end ? issue.scheduled_end : issue.appt_start,
          backgroundColor: eventColor,
          borderColor: eventColor,
          allDay: false, 
          display: 'block', 
          extendedProps: { 
            status: issue.status,
            staff: issue.staff_name 
          } 
        };
      });
      setEvents([...issueEvents]);
    } catch (err) { console.error("Fetch Error:", err); }
  }, []);

  useEffect(() => { if (user) getEventList(); }, [user, getEventList]);

  const displayedEvents = hideClosed 
    ? events.filter(e => e.extendedProps.status !== 'closed') 
    : events;

  const handleResolveSubmit = async () => {
    try {
      const cleanId = selectedEventId.toString().replace('issue-', '');
      await axiosClient.post(`close-issue/${cleanId}/`, {
        end_time: resolveData.endTime,
        comment: resolveData.comment
      });
      setOpenResolveModal(false);
      getEventList();
    } catch (err) {
      alert("Error: " + (err.response?.data?.error || "Failed to close task"));
    }
  };

  return (
    <div>
      <Box sx={{ 
        mb: 2, 
        display: 'flex', 
        flexDirection: isMobile ? 'column' : 'row', 
        justifyContent: 'space-between', 
        alignItems: isMobile ? 'stretch' : 'center',
        gap: 1.5 
      }}>
        <Typography variant={isMobile ? "h6" : "h5"} fontWeight="bold">
          {user?.user_role === "ADMIN" || user?.user_role === "RECEPTION" 
            ? "Hotel Management" 
            : "My Tasks"}
        </Typography>

        <Box sx={{ 
          display: 'flex', 
          gap: 1, 
          width: isMobile ? '100%' : 'auto', 
        }}>
          <Button 
            variant="outlined" 
            color="secondary"
            onClick={() => setHideClosed(!hideClosed)}
            sx={{ 
              fontWeight: 'bold', 
              flex: 1, 
              fontSize: isMobile ? '0.7rem' : '0.85rem',
              whiteSpace: 'nowrap'
            }}
          >
            {hideClosed 
              ? (isMobile ? "Show All" : "Show Closed Tasks") 
              : (isMobile ? "Hide Closed" : "Remove Closed Tasks")
            }
          </Button>

          {(user?.user_role === "ADMIN" || user?.user_role === "RECEPTION") && (
            <Button 
              variant="contained" 
              color="primary" 
              onClick={() => setView("create_issue")}
              sx={{ 
                fontWeight: 'bold', 
                flex: 1,
                fontSize: isMobile ? '0.7rem' : '0.85rem',
                whiteSpace: 'nowrap'
              }}
            >
              {isMobile ? "New Issue" : "Log New Issue"}
            </Button>
          )}
        </Box>
      </Box>

      <DaysCalendar 
        events={displayedEvents} 
        // ✅ Clicking a date now opens the "Create Issue" screen
        onDateClick={(info) => {
          if (user?.user_role === "ADMIN" || user?.user_role === "RECEPTION") {
            setView("create_issue");
          }
        }}
        onEventClick={(info) => { 
          const cleanId = info.event.id.replace('issue-', '');
          setSelectedEventId(cleanId);
          if (user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") {
            setResolveData({ endTime: getLocalDateTimeString(), comment: "" });
            setOpenResolveModal(true);
          } else {
            setOpenEditModal(true); 
          }
        }} 
      />

      <AppointmentEditModal 
        open={openEditModal} 
        id={selectedEventId} 
        handleClose={() => setOpenEditModal(false)} 
        refresh={getEventList} 
      />

      <Dialog open={openResolveModal} onClose={() => setOpenResolveModal(false)} fullWidth maxWidth="xs">
        <DialogTitle sx={{ fontWeight: 'bold' }}>Complete Task</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={3} sx={{ mt: 1 }}>
            <TextField
              label="End Date & Time"
              type="datetime-local"
              fullWidth
              value={resolveData.endTime}
              onChange={(e) => setResolveData({ ...resolveData, endTime: e.target.value })}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="Staff Comments"
              multiline rows={4} fullWidth
              value={resolveData.comment}
              onChange={(e) => setResolveData({ ...resolveData, comment: e.target.value })}
            />
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setOpenResolveModal(false)}>Cancel</Button>
          <Button variant="contained" color="success" onClick={handleResolveSubmit}>
            Submit & Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default FullCalendarApp;